import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SuperListModel } from 'src/app/shared/models/superCompos/super-list-model';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { Nature } from 'src/app/shared/models/iCourrier/nature';
import { Source } from 'src/app/shared/models/iCourrier/source';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { catchError, forkJoin, of, Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/shared/services/data.service';
import { MailInsert } from 'src/app/shared/models/iCourrier/post/mail-insert';
import * as async from 'async';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { CModeChoiceModalComponent } from 'src/app/components/modals/c-mode-choice-modal/c-mode-choice-modal.component';
import { MailTypeModalComponent } from 'src/app/components/modals/mail-type-modal/mail-type-modal.component';
import { Title } from '@angular/platform-browser';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ActionCreateModalComponent } from '../../ACTIONS/action-create-modal/action-create-modal.component';
import { RecipientModalComponent } from '../../COURRIER-S/recipient-modal/recipient-modal.component';
import { DuplicateModalsComponent } from 'src/app/components/modals/duplicate-modals/duplicate-modals.component';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Tree } from 'primeng/tree';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { RightManagement } from 'src/app/shared/models/iCourrier/right/right-management';
import { DocumentStatus } from 'src/app/shared/models/iCourrier/status-management/document-status';
import { ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { PersonalParams, PersonalParamsParams } from 'src/app/shared/models/iCourrier/me/personal-params';
import { MeRightMailGlobal } from 'src/app/shared/models/iCourrier/me/right-mail-global';
import { Cols } from 'src/app/shared/models/cols';
import { ServicesService } from 'src/app/shared/services/services.service';
import { ContactDto, LowInformationsDTO, NatureCustomFieldDto, NatureDto, SourceDto } from 'src/app/shared/interfaces';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { DocumentStatusDto } from 'src/app/shared/interfaces/documents/document-status-dto.interface';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { ConfigService } from 'src/app/shared/services/config.service';
import * as lodash from 'lodash';
import { SourcesService } from 'src/app/shared/services/sources.service';
import { NaturesService } from 'src/app/shared/services/natures.service';
import { MultipleStatutesService } from 'src/app/shared/services/multiple-statutes.service';
import { MultipleStatutesDTO } from 'src/app/shared/models/iCourrier/status-management/multiple-statutes';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { MailsService } from 'src/app/shared/services/mails.service';
import { MailsRightsService } from 'src/app/shared/services/mails-rights.service';
import { MeService } from 'src/app/shared/services/me.service';
import { searchParamsConverterByType } from 'src/app/shared/utils/searchParamsConverterByType.utils';
import { MeRightMail } from 'src/app/shared/models/iCourrier/me/right-mail-id';
import { Mail, MailFromAPI, MailInfosViaExtraStateRouter } from 'src/app/shared/models/mails/mail';
import { MailDTO } from 'src/app/shared/interfaces/mails/mail-dto.interface';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { MailsLockUnlockService } from 'src/app/shared/services/mails-lock-unlock.service';
import { MailLockEntryDTO } from 'src/app/shared/interfaces/mails/mails-lock-dto.interface';
import { MailsMeSearchParams } from 'src/app/shared/models/mails/mails-me-search';
import { RecipientModalOnCloseDatas } from 'src/app/shared/models/recipient-modal';
import { environment } from 'src/environments/environment';
import { manageServicesSetAsTreeSelect } from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { ContactsRemplacantDTO, MailDetailsCustomNatureDataDto } from 'src/app/shared/models';

@Component({
  selector: 'app-home-courrier-child',
  templateUrl: './home-courrier-child.component.html',
  styleUrls: ['./home-courrier-child.component.scss'],
})
export class HomeCourrierChildComponent implements OnInit, OnDestroy {
  @ViewChild('overlayButton') overlayButton: OverlayPanel;
  @ViewChild('searchButton') searchButton: IButton;
  @ViewChild('pTree') pTree: Tree;

  //#Region new visual
  public tabsArrayNewVisual: { title: string; slug: string; active?: boolean; icon: string }[] = [
    { title: 'homeCourrierChild.view.list', slug: 'list', active: true, icon: 'bi bi-eye-fill' },
    { title: 'homeCourrierChild.view.table', slug: 'table', icon: 'bi bi-table' },
  ];
  public selectedTabArrayNewVisual = { title: 'homeCourrierChild.view.list', slug: 'list', active: true };
  //#endregion

  public chgActiveMailSubject: Subject<Mail> = new Subject<Mail>();
  public welcomeMode: boolean;
  public title = '';
  public iconClass: string;
  public selected: string;
  public superListTools: { click: () => void };
  public mailActive: Mail;
  public newMailActive: Mail;
  public fullViewMode: boolean;
  public searchString = '';
  public reduceAll = false;
  public clientType: string = sessionStorage.getItem('clientType');

  public fileToConvert: File;
  public isScanMode = false;

  public natureList: Nature[];
  public sourceList: Source[];
  public DateFilter: {
    DtEntreeMin: string | Date;
    DtEntreeMax: string | Date;
  } = null;
  public showInputText = false;

  // Select Options
  //Ajouté l'iconColor au cas ou mais pas utilisé pour le moment comme l’icône a de base la bonne couleur :)
  public boxes: {
    name: string;
    count: number;
    menu: string;
    title: string;
    icon: string;
    iconColor: string;
    click: () => void;
  }[] = [
    {
      name: 'all',
      count: 0,
      menu: 'all',
      title: 'Tous les courriers',
      icon: 'dashboard-icon-all',
      iconColor: 'rgb(36, 52, 75)',
      click: () => {
        this.router.navigate(['/private/ic/courriers/all']);
        sessionStorage.removeItem('reloadData');
      },
    },
    {
      name: 'entrants',
      count: 0,
      menu: 'entrants',
      title: 'Tous les entrants',
      icon: 'dashboard-icon-entrant',
      iconColor: 'rgb(189, 39, 224)',
      click: () => {
        this.router.navigate(['/private/ic/courriers/entrants']);
      },
    },
    {
      name: 'sortants',
      count: 0,
      menu: 'sortants',
      title: 'Tous les sortants',
      icon: 'dashboard-icon-sortant',
      iconColor: 'rgb(80, 226, 193)',
      click: () => {
        this.router.navigate(['/private/ic/courriers/sortants']);
      },
    },
    {
      name: 'internes',
      count: 0,
      menu: 'internes',
      title: 'Tous les internes',
      icon: 'dashboard-icon-intern',
      iconColor: 'rgb(80,227,194)',
      click: () => {
        this.router.navigate(['/private/ic/courriers/internes']);
      },
    },
    {
      name: 'nonLus',
      count: 0,
      menu: 'nonLus',
      title: 'Non lu(s)',
      icon: 'dashboard-icon-non-lus',
      iconColor: 'rgb(255, 98, 96)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/nonLus']);
      },
    },
    {
      name: 'Lus',
      count: 0,
      menu: 'Lus',
      title: 'Lu(s)',
      icon: 'dashboard-icon-lu',
      iconColor: 'rgb(59, 222, 134)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/Lus']);
      },
    },
    {
      name: 'PourInfo',
      count: 0,
      menu: 'PourInfo',
      title: 'Pour information',
      icon: 'dashboard-icon-pour-info',
      iconColor: 'rgb(50, 197, 255)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/PourInfo']);
      },
    },
    {
      name: 'aPrendreEnCharge',
      count: 0,
      menu: 'aPrendreEnCharge',
      title: 'Prise en charge pour mon service',
      icon: 'dashboard-icon-prendre-en-charge',
      iconColor: 'rgb(36, 52, 75)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/aPrendreEnCharge']);
      },
    },
    {
      name: 'prisEnCharge',
      count: 0,
      menu: 'prisEnCharge',
      title: 'Prise en charge demandée par mon service',
      icon: 'dashboard-icon-demandes-de-prises-en-charge',
      iconColor: 'rgb(247, 181, 0)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/prisEnCharge']);
      },
    },
    {
      name: 'NonPrisEnCharge',
      count: 0,
      menu: 'NonPrisEnCharge',
      title: 'Demandes non prises en charge par mon service',
      icon: 'dashboard-icon-demandes-non-prises-en-charge',
      iconColor: 'rgb(255, 98, 96)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/NonPrisEnCharge']);
      },
    },
    {
      name: 'AValider',
      count: 0,
      menu: 'AValider',
      title: 'Courriers entrants à valider',
      icon: 'dashboard-icon-a-valider',
      iconColor: 'rgb(189, 39, 224)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigateByUrl('/private/ic/courriers/AValider');
      },
    },
    {
      name: 'ADistribuer',
      count: 0,
      menu: 'aDistribuer',
      title: 'A distribuer',
      icon: 'dashboard-icon-a-distribuer',
      iconColor: 'rgb(255, 184, 71)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/ADistribuer']);
      },
    },
    {
      name: 'ACompleter',
      count: 0,
      menu: 'aCompleter',
      title: 'A compléter',
      icon: 'dashboard-icon-a-completer',
      iconColor: 'rgb(36, 52, 75)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/ACompleter']);
      },
    },
    {
      name: 'MalRoutes',
      count: 0,
      menu: 'malRoutes',
      title: 'Mal routé(s)',
      icon: 'dashboard-icon-mal-routes',
      iconColor: 'rgb(189, 39, 224)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/MalRoutes']);
      },
    },
    {
      name: 'epingles',
      count: 0,
      menu: 'epingles',
      title: 'Epinglé(s)',
      icon: 'dashboard-icon-epingles',
      iconColor: 'rgb(247, 181, 0)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/epingles']);
      },
    },
    {
      name: 'pourAction',
      count: 0,
      menu: 'pourAction',
      title: 'Pour action',
      icon: 'dashboard-icon-pour-action',
      iconColor: 'rgb(96, 205, 255)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/pourAction']);
      },
    },
    {
      name: 'recemmentConsultes',
      count: 0,
      menu: 'recemmentConsultes',
      title: 'Récemment consulté(s)',
      icon: 'dashboard-icon-recemment-consultes',
      iconColor: 'rgb(80, 226, 193)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/recemmentConsultes']);
      },
    },
    {
      name: 'recemmentCrees',
      count: 0,
      menu: 'recemmentCrees',
      title: 'Récemment créé(s)',
      icon: 'dashboard-icon-recemment-crees',
      iconColor: 'rgb(96, 205, 255)',
      click: () => {
        sessionStorage.removeItem('reloadData');
        sessionStorage.removeItem('searchData');
        this.router.navigate(['/private/ic/courriers/recemmentCrees']);
      },
    },
    {
      name: 'AClasser',
      count: 0,
      menu: 'aClasser',
      title: 'Courrier à classer',
      icon: 'dashboard-icon-a-classer',
      iconColor: 'rgb(255, 184, 71)',
      click: () => {
        this.router.navigate(['/private/ic/courriers/AClasser']);
      },
    },
  ];

  public currentCount: number;

  public mails: Mail[] = [];
  public list: SuperListModel[] = [];
  public isLoading = false;
  public idMailActive: number;

  public contacts: Contact[];
  public contactsiAdmin: Contact[];
  public typeEntrantSortant = '';

  public userInfos: UserInfo; // Access of the connected user
  public userRights: RightManagement; // Rights of the connected user
  public slugUrl: string;

  public daysModel = '';
  public pageNumber: number;
  public searchLoaded = true;
  public globalStatus: DocumentStatus[] = [];
  public numberCourrier = 0;
  public totalPages = 0;
  public searchParams: { [key: string]: number | string } = {}; // for scrolling with those params
  public enableMultiselect = true;
  public multipleItemsSelected: Mail[] = [];

  public sizeChoice = 50;
  public sizeOfPages = [];
  public advancedSearch = false;
  public formSearch = new UntypedFormGroup({
    Confidentiel: new UntypedFormControl(null),
    DtEntreeMin: new UntypedFormControl(null),
    DtEntreeMax: new UntypedFormControl(null),
    Type: new UntypedFormControl(null),
    Tag: new UntypedFormControl(null),
    ClassementIds: new UntypedFormControl(null),
    SvcPropIds: new UntypedFormControl(null),
    StIds: new UntypedFormControl(null),
    ExpediteurIds: new UntypedFormControl(null),
    DestinataireIds: new UntypedFormControl(null),
    DestinataireServiceIds: new UntypedFormControl(null),
    NatureIds: new UntypedFormControl(null),
    SourceIds: new UntypedFormControl(null),
    MultipleStIds: new UntypedFormControl(null),
    recurrence: new UntypedFormControl(null),
    DtEcheanceMin: new UntypedFormControl(null),
    DtPostaleMin: new UntypedFormControl(null),
    DtPostaleMax: new UntypedFormControl(null),
    DtCreationMin: new UntypedFormControl(null),
    DtCreationMax: new UntypedFormControl(null),
    dateCourrier: new UntypedFormControl(null),
    dateEntree: new UntypedFormControl(null),
    DtEcheanceMax: new UntypedFormControl(null),
    DtDocumentMin: new UntypedFormControl(null),
    DtDocumentMax: new UntypedFormControl(null),
    Remarques: new UntypedFormControl(null),
    Objet: new UntypedFormControl(null),
    Text: new UntypedFormControl(null),
    BoolObjetText: new UntypedFormControl(null),
    Key: new UntypedFormControl(null),
    BoiteArchive: new UntypedFormControl(null),
    Id: new UntypedFormControl(null),
    ExpediteurLibre: new UntypedFormControl(null),
    DestinataireLibre: new UntypedFormControl(null),
    CourrierSansDestinataires: new UntypedFormControl(null),
    CourrierSansServices: new UntypedFormControl(null),
    ReferenceRecommande: new UntypedFormControl(null),
    typeOfAdvancedSearch: new UntypedFormControl(false),
  });
  public serviceParent: ServicesPTreeSelect[] = []; //array with the arborescence
  public natureListLV: { label: string; value: number; natureCustomFields: NatureCustomFieldDto[] }[] = [];
  public listOfNatures: Nature[] = [];
  public tags: { label: string; value: number }[] = [];
  public sourceListLV: { label: string; value: number }[] = [];
  public statutGlobalLV: { label: string; value: number; color: string }[] = [];
  public currentTag = '';
  public openSavedSearchs = false;

  public itemsSaved: PersonalParams[] = [];
  public savedModal = false;
  public updateMode = false;
  public hideSomeElementInSideMenu = false;
  public rightMailGlobal: MeRightMailGlobal;
  public selectedTabs = 'list';

  public columnTable: Cols[] = [];
  public itemsMenu: { label?: string; icon?: string; command?: (item) => void }[] = [
    {
      label: 'homeCourrierChild.advancedSearch.seeForm',
      icon: 'pi pi-fw pi-search',
      command: () => {
        this.showDialog(this.selectedCourrierForMenu);
      },
    },
    {
      label: 'homeCourrierChild.advancedSearch.respond',
      icon: 'icon-forward',
      command: () => {
        this.openCreateModal(this.selectedCourrierForMenu);
      },
    },
  ];
  public selectedCourrierForMenu: Mail = null;
  public forselection: { click: (item) => void; label: string; tooltip: string }[] = [];
  public mailsObject: MailFromAPI;
  public idTable = 'idTables';
  public currentView: PersonalParams = null;

  public hasAdvancedSearch = false;
  public contactInfoComplementary: {
    type: string;
    societeParente: string;
    impression_Adresse: string;
    impression_CodePostal: string;
    impression_Localite: string;
    impression_Pays: string;
    gsm: string;
    telephone: string;
    mail: string;
  }[] = [];
  public display = false;

  public chosenNatureForAdvancedSearchComplDatas = null;
  public dropdownLabel;
  public dropdownValue = 'Recherche basique';
  public showOverlayDropdown = false;
  public onFocusInput = false;
  public activeModeSearch = 'normalSearch'; // can contains 2 vars : 'normalSearch' will display basic search input ; 'serviceSearch' will display a special input for the service search
  public openModalTreeServicesSelection = false;
  public selectedOption = [];
  public translationPlaceholderPTree = '';
  public inputDisplayOnServiceSearch = '';
  public inputDisplayOnServiceSearchTooltip = '';
  public inputDisplayOnAdvancedSearch = '';
  public advancedSearchDatas: {
    [key: string]: unknown;
  } = null;
  public advancedSearchArray = [];
  public displaySuperTableTableView = true;
  public nextPageMail = [];

  public flagStoppingTheRequest = false;
  public flagStoppingTheRequestId = null;

  public subjectCanAccessToMail: Subscription;
  private routeParamsSubscription: Subscription;

  public resetSelectedItems = false;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    public router: Router,
    public location: Location,
    private spinner: NgxSpinnerService,
    private dataService: DataService,
    public toastr: ToastrService,
    public confirmService: ConfirmationService,
    private dialogService: DialogService,
    private translater: TranslateService,
    private servicesService: ServicesService,
    private contactsService: ContactsService,
    private multipleStatutesService: MultipleStatutesService,
    private documentsService: DocumentsService,
    private configService: ConfigService,
    private sourcesService: SourcesService,
    private naturesServices: NaturesService,
    private recipientsService: RecipientsService,
    private mailsService: MailsService,
    private mailsRightsService: MailsRightsService,
    private meService: MeService,
    private groupsService: GroupsService,
    private mailsLockUnlockService: MailsLockUnlockService,
    private classificationsService: ClassificationsService
  ) {}
  public configuration: ConfigDto;
  ngOnInit(): void {
    this.subjectCanAccessToMail?.unsubscribe();
    this.subjectCanAccessToMail = this.mailsService.canAccessToMail.subscribe({
      next: (res) => {
        if (res) {
          this.markAsReaded(res);
        }
      },
    });
    this.getData();
    this.isLoading = true;
    this.getTranslations();
    this.nextPageMail = [
      {
        title: this.translater.translate('courrierFiche.displayMoreMails'),
        statusColorClass: 'no_border', //Obligatoire si on ne veut pas avoir la bordure de "non-lu",
        isTheItemToDisplayMoreMails: true,
      },
    ];
    this.dataService.setSidebarSmall(true);

    this.spinner.show();
    this.searchString = '';
    this.mails = [];
    this.getCustomView();

    this.getMainQueriesForInit().then(() => {
      this.meService.rightMailGlobal().subscribe({
        next: (res: MeRightMailGlobal) => {
          this.rightMailGlobal = res;
          this.boxes.map((box) => {
            if (box.menu === 'aCompleter') {
              box['hide'] = this.rightMailGlobal.menu['aCompleter'] === false ? true : false;
            } else if (box.menu === 'aDistribuer') {
              box['hide'] = this.rightMailGlobal.menu['aDistribuer'] === false ? true : false;
            } else if (box.menu === 'malRoutes') {
              box['hide'] = this.rightMailGlobal.menu['malRoutes'] === false ? true : false;
            } else if (box.menu === 'prisEnCharge' || box.menu === 'aPrendreEnCharge' || box.menu === 'NonPrisEnCharge') {
              if (
                this.rightMailGlobal.menu['priseEnCharge'] === false ||
                this.configuration.priseEnChargeCourriers?.fermerMasquerPriseEnCharge === true
              ) {
                box['hide'] = true;
              } else {
                box['hide'] = false;
              }
            } else if (box.menu === 'AValider') {
              box['hide'] = this.rightMailGlobal.menu['validation'] === false ? true : false;
            } else if (box.menu === 'aClasser') {
              box['hide'] = this.rightMailGlobal.menu['aClasser'] === false ? true : false;
            } else {
              box['hide'] = false;
            }
          });
          // On récupère les favoris, on inverse l'array et ensuite on enlève le favori de la liste des box pour le remettre en 1ere position.
          // on inverse l'array comme cela le dernier ajouté sera le 1er en haut de la liste

          let favorites = JSON.parse(localStorage.getItem('iCourrierBoxes'))[0];
          favorites = favorites.reverse();
          favorites.forEach((fav) => {
            const index = this.boxes.map((box) => box.name).indexOf(fav.name);
            if (index > -1) {
              this.boxes.splice(index, 1);
              this.boxes.splice(0, 0, fav);
            }
          });
          this.boxes = this.boxes.filter((x) => x['hide'] === false);
        },
      });

      this.routeParamsSubscription?.unsubscribe();
      this.routeParamsSubscription = this.route.params.subscribe({
        next: (urlParam) => {
          if (urlParam?.title === 'advancedSearch') {
            const dataFromURL = this.route.snapshot.queryParamMap.get('advancedSearchData');
            const searchParams = new URLSearchParams(dataFromURL);
            const searchData: { [key: string]: string } = {};

            searchParams.forEach((value, key) => {
              searchData[key] = value;
            });

            this.advancedSearchDatas = searchParamsConverterByType(searchData, this.natureListLV);

            if (this.advancedSearchDatas.Id) {
              //s'il y a un id, la recherche se fera dessus
              this.mailsService.fetchMailsById(+this.advancedSearchDatas.Id).subscribe({
                next: (response: MailDTO) => {
                  if (response) {
                    let mailResponse = new Mail(response);
                    this.mails = [];
                    this.searchLoaded = true;
                    this.pageNumber = 1;
                    this.numberCourrier = 1;
                    if (mailResponse.statutId && this.globalStatus.length > 0) {
                      mailResponse = this.setMailStatus(mailResponse);
                    }
                    if (mailResponse.sourceId && this.sourceListLV.length > 0) {
                      mailResponse = this.setMailSource(mailResponse);
                    }
                    this.setExpediteur(mailResponse).then((mail) => {
                      mailResponse = new Mail(mail);
                      this.manageMail(mailResponse);
                      this.advancedSearchArray = [{ label: 'Id', value: this.advancedSearchDatas.Id }];
                    });
                  } else {
                    this.spinner.hide();
                    this.isLoading = false;
                    this.mails = [];
                  }
                },
                error: (err) => {
                  console.error(err);
                  this.spinner.hide();
                  this.isLoading = false;
                  this.mails = [];
                },
              });
            } else {
              this.getAllMailsCount(lodash.cloneDeep(this.advancedSearchDatas));
              const data = {
                ...lodash.cloneDeep(this.advancedSearchDatas),
                CalcTotal: false,
              };

              this.mailsService.getAllMails(data, this.sizeChoice).subscribe({
                next: (response) => {
                  this.mailsObject = response;
                  this.mails = [];
                  this.pageNumber = response.pageNumber;

                  // On va commencer par récupérer les expéditeurs de iCourrier
                  const sendersiCourrierFromResponse = _.uniq(
                    response.items.filter((expediteur) => !!expediteur.expediteurId).map((expediteur) => expediteur.expediteurId)
                  );
                  const sendersiCourrierFromQuery = data.ExpediteurIds || [];
                  const recipientiCourrierFromQuery = data.DestinataireIds || [];
                  const listOfExpediteuriCourrierIds = _.uniq([
                    ...sendersiCourrierFromResponse,
                    ...sendersiCourrierFromQuery,
                    ...recipientiCourrierFromQuery,
                  ]);

                  // Puis on va faire de même avec les expéditeurs de iAdmin
                  const sendersiAdminFromResponse = _.uniq(
                    response.items.filter((expediteur) => !!expediteur.expediteurIdiAdmin).map((expediteur) => expediteur.expediteurIdiAdmin)
                  );
                  const sendersiAdminFromQuery = data.ExpediteurIdiAdmins || [];
                  const recipientiAdminFromQuery = data.DestinataireIdiAdmins || [];
                  const listOfExpediteuriAdminIds = _.uniq([...sendersiAdminFromResponse, ...sendersiAdminFromQuery, ...recipientiAdminFromQuery]);

                  forkJoin({
                    lowInfoIC: listOfExpediteuriCourrierIds.length
                      ? this.getLowInformationsContactIds(listOfExpediteuriCourrierIds, 'getLowInformationsContactsiCourrier')
                      : of([]),
                    lowInfosIAdmin: listOfExpediteuriAdminIds.length
                      ? this.getLowInformationsContactIds(listOfExpediteuriAdminIds, 'getLowInformationsContactsiAdmin')
                      : of([]),
                  }).subscribe((value) => {
                    this.contacts = value.lowInfoIC.map((expediteur) => new Contact(expediteur));
                    this.contactsiAdmin = value.lowInfosIAdmin.map((expediteur) => new Contact(expediteur));

                    if (response.items?.length) {
                      response.items.forEach((mail) => {
                        let mailFullInfo = new Mail(mail);

                        if (mailFullInfo.statutId && this.globalStatus.length > 0) {
                          mailFullInfo = this.setMailStatus(mailFullInfo);
                        }
                        if (mailFullInfo.sourceId && this.sourceListLV.length > 0) {
                          mailFullInfo = this.setMailSource(mailFullInfo);
                        }
                        if (mailFullInfo.expediteurId) {
                          const foundSender = this.contacts.find((contact) => contact.id === mailFullInfo.expediteurId);
                          if (foundSender) {
                            mailFullInfo.expTitle =
                              (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                          }
                        } else if (mailFullInfo.expediteurIdiAdmin) {
                          const foundSender = this.contactsiAdmin.find((contact) => contact.id === mailFullInfo.expediteurIdiAdmin);
                          if (foundSender) {
                            mailFullInfo.expTitle =
                              (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                          }
                        }
                        this.mails.push(mailFullInfo);
                      });
                      this.getColumns();

                      if (!this.mailActive) {
                        this.getMailActive(this.mails[0].id);
                        this.mailActive = this.mails[0];
                        this.mailActive.active = true;
                        this.dataService.setMailActive(this.mailActive); // emit to ficheForm and courrierFicheHeader
                      }
                    }

                    // this.advancedSearchArray doit être set a la fin car le display filters se base sur la réception de cette variable pour trigger sa méthode d'affichage. OR si on reçoit this.advancedSearchArray SANS this.contacts eh bien y'a un soucis de find sur une donnée vide. Et non, mettre this.contact à vide ne résoudra pas, car alors le display filters n'affichera aucun expéditeur...
                    this.advancedSearchArray = Object.keys(this.advancedSearchDatas).map((key) => ({
                      label: key,
                      value: this.advancedSearchDatas[key],
                    }));
                    this.isLoading = false;
                    this.spinner.hide();
                  });
                },
                error: (err) => {
                  console.error(err);
                  this.spinner.hide();
                  this.isLoading = false;
                  this.mails = [];
                  this.toastr.error(this.translater.translate('errorOccurredWhenRecoveringDatas'));
                },
              });
            }
          } else {
            this.hasAdvancedSearch = false;
            this.advancedSearchDatas = null;
            this.dataService.reloadInfoBool.subscribe({
              next: (res) => {
                if (res) {
                  this.reset();
                }
              },
            });
            let searchData = null;
            if (sessionStorage.getItem('reloadData') === 'oui') {
              if (sessionStorage.getItem('searchData') !== null) {
                searchData = JSON.parse(sessionStorage.getItem('searchData'));
                if (searchData.Key) {
                  this.searchString = searchData.Key;
                  delete searchData.Key;
                }
                if (!searchData.Id) {
                  searchData.Id = null;
                }
              }
            }
            //Si on a un searchData c'est qu'on a cliqué sur une recherche sauvegardée
            if (searchData) {
              this.hasAdvancedSearch = true;
              this.advancedSearchDatas = searchData;
              this.currentTag = searchData.Tag ? searchData.Tag : 'all';
              // Ici on va devoir vérifier s'il y a des récurrences de dates.
              // En effet, dans la recherche sauvegardée, lorsque l'on a une récurrence, les dates sont remplacées via un moment.diff et ce diff va être appliqué à la date du jour.
              // Il faut donc absolument faire le même traitement ici
              if (this.advancedSearchDatas.recurrence) {
                if (this.advancedSearchDatas.DtDocumentMin) {
                  const diff = moment(this.advancedSearchDatas.DtDocumentMax).diff(moment(this.advancedSearchDatas.DtDocumentMin), 'days');
                  this.advancedSearchDatas.DtDocumentMax = diff ? moment().add(diff, 'days').format('YYYY-MM-DD') : null;
                  this.advancedSearchDatas.DtDocumentMin = this.advancedSearchDatas.DtDocumentMin ? moment().format('YYYY-MM-DD') : null;
                }
                if (this.advancedSearchDatas.DtEcheanceMin) {
                  const diff = moment(this.advancedSearchDatas.DtEcheanceMax).diff(moment(this.advancedSearchDatas.DtEcheanceMin), 'days');
                  this.advancedSearchDatas.DtEcheanceMax = diff ? moment().add(diff, 'days').format('YYYY-MM-DD') : null;
                  this.advancedSearchDatas.DtEcheanceMin = this.advancedSearchDatas.DtEcheanceMin ? moment().format('YYYY-MM-DD') : null;
                }
                if (this.advancedSearchDatas.DtEntreeMin) {
                  const diff = moment(this.advancedSearchDatas.DtEntreeMax).diff(moment(this.advancedSearchDatas.DtEntreeMin), 'days');
                  this.advancedSearchDatas.DtEntreeMax = diff ? moment().add(diff, 'days').format('YYYY-MM-DD') : null;
                  this.advancedSearchDatas.DtEntreeMin = this.advancedSearchDatas.DtEntreeMin ? moment().format('YYYY-MM-DD') : null;
                }
                if (this.advancedSearchDatas.DtPostaleMin) {
                  const diff = moment(this.advancedSearchDatas.DtPostaleMax).diff(moment(this.advancedSearchDatas.DtPostaleMin), 'days');
                  this.advancedSearchDatas.DtPostaleMax = diff ? moment().add(diff, 'days').format('YYYY-MM-DD') : null;
                  this.advancedSearchDatas.DtPostaleMin = this.advancedSearchDatas.DtPostaleMin ? moment().format('YYYY-MM-DD') : null;
                }
                if (this.advancedSearchDatas.DtEncodageMin) {
                  const diff = moment(this.advancedSearchDatas.DtEncodageMax).diff(moment(this.advancedSearchDatas.DtEncodageMin), 'days');
                  this.advancedSearchDatas.DtEncodageMax = diff ? moment().add(diff, 'days').format('YYYY-MM-DD') : null;
                  this.advancedSearchDatas.DtEncodageMin = this.advancedSearchDatas.DtEncodageMin ? moment().format('YYYY-MM-DD') : null;
                }
                if (this.advancedSearchDatas.DtCreationMin) {
                  const diff = moment(this.advancedSearchDatas.DtCreationMax).diff(moment(this.advancedSearchDatas.DtCreationMin), 'days');
                  this.advancedSearchDatas.DtCreationMax = diff ? moment().add(diff, 'days').format('YYYY-MM-DD') : null;
                  this.advancedSearchDatas.DtCreationMin = this.advancedSearchDatas.DtCreationMin ? moment().format('YYYY-MM-DD') : null;
                }
              }
              const data = this.cleanObject(searchData);
              if (data.Id) {
                this.getMailById(data.Id);
              } else {
                //on set un tag au cas ou y'en a pas puis on va setter la catégorie si elle n'existe pas
                !searchData.Tag ? (searchData.Tag = 'All') : null;
                !searchData.category ? (searchData.category = searchData.Tag) : null;

                this.getMails(data, this.title).then(() => {
                  this.advancedSearchArray = Object.keys(searchData).map((key) => ({
                    label: key,
                    value: searchData[key],
                  }));
                });
              }
            } else {
              this.currentTag = sessionStorage.getItem('Tag');
              // GetAllCount and boxes
              this.reduceAll = false;
              localStorage.removeItem('isAnswer');
              this.getUserInfos().then(() => {
                this.slugUrl = urlParam.title;
                this.selected = urlParam.title;
                const boxChosen = this.boxes.find((box) => box.name === this.selected);
                if (this.slugUrl === 'bacs') {
                  this.getMailsParams(this.slugUrl);
                } else {
                  if (boxChosen) {
                    this.setBoxNameAndCount(boxChosen);
                    this.title = '';
                    this.iconClass = boxChosen.icon;
                    this.title = boxChosen.title;

                    this.getRouteParams();
                    localStorage.removeItem('activeCategoryCourrier');
                    localStorage.setItem('activeCategoryCourrier', boxChosen.name);
                  }
                }
                this.subscribeToRefresh();
              });
            }
          }
        },
      });
    });
  }

  ngOnDestroy(): void {
    this.subjectCanAccessToMail.unsubscribe();
    this.routeParamsSubscription?.unsubscribe();
    sessionStorage.removeItem('searchData');
    sessionStorage.removeItem('filter-search');
    sessionStorage.removeItem('reloadData');
    sessionStorage.removeItem('advancedSearch');
    delete window['advancedSearchDatas'];
  }

  private getTranslations(): void {
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectOneOrMultipleServices');
    this.tabsArrayNewVisual.map((tab) => {
      tab.title = this.translater.translate(tab.title);
    });
    this.sizeOfPages = [
      { label: this.translater.translate('homeCourrierChild.maxTable', { value: 50 }), value: 50 },
      { label: this.translater.translate('homeCourrierChild.maxTable', { value: 200 }), value: 200 },
      { label: this.translater.translate('homeCourrierChild.maxTable', { value: 500 }), value: 500 },
      { label: this.translater.translate('homeCourrierChild.maxTable', { value: 1000 }), value: 1000 },
      { label: this.translater.translate('homeCourrierChild.maxTable', { value: 5000 }), value: 5000 },
    ];
    this.itemsMenu.map((menu) => {
      menu.label = this.translater.translate(menu.label);
    });
    this.dropdownLabel = this.translater.translate('homeCourrierChild.basicSearch');
  }

  getMainQueriesForInit(): Promise<boolean> {
    return new Promise((resolve) => {
      forkJoin({
        config: this.configService.fetchConfig().pipe(
          catchError(() => {
            this.toastr.error('Une erreur est survenue lors de la récupération des paramètres globaux de configuration');
            return of(null);
          })
        ),
        sources: this.sourcesService.fetchSources().pipe(
          catchError(() => {
            this.toastr.error('Une erreur est survenue lors de la récupération des sources');
            return of(null);
          })
        ),
        natures: this.naturesServices.fetchNatures().pipe(
          catchError(() => {
            this.toastr.error('Une erreur est survenue lors de la récupération des natures');
            return of(null);
          })
        ),
        services: this.servicesService.fetchMappedServicesToPrimeNGDropdowns().pipe(
          catchError(() => {
            this.toastr.error('Une erreur est survenue lors de la récupération des services');
            return of(null);
          })
        ),
        documentStatus: this.documentsService.fetchDocumentsStatutes().pipe(
          catchError(() => {
            this.toastr.error('Une erreur est survenue lors de la récupération des statuts de documents');
            return of(null);
          })
        ),
      }).subscribe((value) => {
        this.configuration = value.config;
        this.formatSources(value.sources);
        this.formatNatures(value.natures);
        const datasForService = manageServicesSetAsTreeSelect(value.services, this.translater);
        this.serviceParent = datasForService.servicesForSingleCheck;
        this.globalStatus = value.documentStatus;
        resolve(true);
      });
    });
  }

  private formatSources(sources: SourceDto[]): void {
    this.sourceListLV = [];
    sources.forEach((item) => {
      this.sourceListLV.push({ label: item.description, value: item.id });
    });
  }

  private formatNatures(natures: NatureDto[]): void {
    this.dataService.setListOfNatures(natures);
    this.listOfNatures = natures;
    natures.forEach((item) => {
      this.natureListLV.push({
        label: item.description,
        value: item.id,
        natureCustomFields: item.natureCustomFields,
      });
    });
  }

  onReachEndDetermineWitchMethodToCall(): void {
    if (!this.advancedSearchDatas) {
      this.scrollMethods();
    } else {
      this.advancedSearchDatas.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
      this.searchMailAdvancedSearch(true, true);
    }
  }

  getData(): void {
    this.superListTools = {
      click: this.openMail,
    };
  }

  getComplDatasForNatureChosen(event): void {
    this.idTable = 'idTable';

    //d'abord on va enlever toutes les colonnes de données complémentaires s'il y en a (par ex, au 2 eme choix de natures)
    const indexesOfComplDatas = [];
    this.columnTable.forEach((x, index) => {
      if (x.id && x.id === 'complementaryDatas') {
        indexesOfComplDatas.push(index);
      }
    });

    if (indexesOfComplDatas.length > 0) {
      const indexesOfComplDatasSorted = indexesOfComplDatas.reverse();
      indexesOfComplDatasSorted.map((x) => {
        this.columnTable.splice(x, 1);
      });
    }

    if (event?.value) {
      //une fois cela fait, on peut ajouter les nouvelles données
      const chosenNature = this.listOfNatures.find((x) => x.id === event.value);

      if (chosenNature.natureCustomFields.length > 0) {
        chosenNature.natureCustomFields.forEach((customData) => {
          this.columnTable.splice(this.columnTable.length, 0, {
            field: 'natureCustomFieldId' + customData.id,
            id: 'complementaryDatas',
            header: customData.name,
            visible: true,
            format: (value, item) => {
              const temp = item.natureCustomDatas.find((x) => x.natureCustomFieldId === value);
              return this.setFormatCustomDatas(temp, chosenNature);
            },
          });
        });
        this.displaySuperTableTableView = false;
        this.idTable = this.idTable + chosenNature.description;
        this.displaySuperTableTableView = true;
      } else {
        this.displaySuperTableTableView = false;
        this.idTable = this.idTable + chosenNature.description;
        this.displaySuperTableTableView = true;
        this.toastr.info('Aucune données complémentaires trouvées pour cette nature');
      }
    } else {
      this.displaySuperTableTableView = false;
      this.idTable = this.idTable + 'Cleared';
      this.displaySuperTableTableView = true;
    }
  }

  setFormatCustomDatas(data, chosenNature) {
    if (data) {
      data.type = data.type.toLowerCase();
      if (data.type == 'text' || data.type === 'textarea') {
        return data.textValue;
      }
      if (data.type == 'checkbox') {
        return data.numberValue ? true : false;
      }
      if (data.type == 'integer') {
        return data.numberValue;
      }
      if (data.type == 'decimal') {
        return data.decimalValue;
      }
      if (data.type == 'date') {
        return moment(data.dateValue).isValid() ? moment(data.dateValue).format('DD/MM/YYYY') : '';
      }
      if (data.type === 'dropdown') {
        const foundCustomData = chosenNature.natureCustomFields.find((customField) => customField.id === data.natureCustomFieldId);
        if (foundCustomData) {
          if (data.listValueItemId) {
            const foundLabel = foundCustomData.listItems.find((item) => item.id === data.listValueItemId)?.name;
            return foundLabel ? foundLabel : '';
          } else return '';
        } else return '';
      }
    } else return '';
  }

  getCustomView(): void {
    this.meService.getMyPersonalParams('CourrierCustomViews', this.idTable).subscribe({
      next: (res: PersonalParams[]) => {
        if (res && res.length > 0) {
          this.currentView = _.first(res);
          localStorage.setItem('state-of-table-' + this.idTable, this.currentView.value);
        }
      },
    });
  }

  getUserInfos(): Promise<boolean> {
    return new Promise((resolve) => {
      this.meService.getUserInfo().subscribe({
        next: (response: UserInfo) => {
          this.userInfos = response;
          this.meService.rightManagement().subscribe({
            next: (res: RightManagement) => {
              this.userRights = res;
              resolve(true);
            },
          });
        },
        error: (error) => {
          console.error('Error : ', error);
        },
      });
    });
  }

  back(): void {
    this.router.navigateByUrl('/private/ic/courriers');
  }

  getRouteParams(): void {
    const title = this.route.snapshot.params.title;
    this.spinner.show();

    this.currentTag = title;

    if (this.currentTag === 'Lus') {
      this.enableMultiselect = false;
    } else {
      this.enableMultiselect = true;
      this.forselection = [
        {
          click: (selections) => {
            this.multipleItemsSelected = selections;
            if (selections && selections.length > 0) {
              this.markAsReadedMultiple(selections);
            }
          },
          label: 'Marquer comme lu',
          tooltip: '',
        },
      ];
      if (this.currentTag === 'AValider') {
        this.forselection.push({
          click: (selections) => {
            this.validate(selections);
          },
          label: 'Valider les courriers',
          tooltip: '',
        });
      } else if (this.currentTag === 'ADistribuer') {
        this.forselection.push({
          click: (selections) => {
            this.distribute(selections);
          },
          label: 'Distribuer les courriers',
          tooltip: '',
        });
      }
    }

    if (this.title) {
      const boxChosen = this.boxes.find((box) => box.title === this.title);

      this.slugUrl = title;
      if (boxChosen) {
        this.setBoxNameAndCount(boxChosen);
        this.iconClass = boxChosen.icon;
        localStorage.removeItem('activeCategoryCourrier');
        localStorage.setItem('activeCategoryCourrier', boxChosen.name);
      }
      this.getMailsParams(this.title);
    } else {
      this.toastr.error(this.translater.translate('homeCourrierChild.impossibleToLoadMail'));
      this.spinner.hide();
    }

    if (sessionStorage.getItem('filter-date')) {
      this.daysModel = sessionStorage.getItem('filter-date');
      this.DateFilter = {
        DtEntreeMin: '',
        DtEntreeMax: '',
      };
      if (this.daysModel !== null) {
        switch (this.daysModel) {
          case 'today':
            this.DateFilter = {
              DtEntreeMin: new Date(),
              DtEntreeMax: new Date(),
            };
            break;
          case 'week':
            this.DateFilter = {
              DtEntreeMin: this.removeDays(new Date(), 7),
              DtEntreeMax: new Date(),
            };
            break;
          case 'month':
            this.DateFilter = {
              DtEntreeMin: this.removeDays(new Date(), 30),
              DtEntreeMax: new Date(),
            };
            break;
          default:
            break;
        }
      }
    }
    if (sessionStorage.getItem('searchData')) {
      const dataSession = JSON.parse(sessionStorage.getItem('searchData'));
      if (dataSession.Key !== null) this.searchString = dataSession.Key;
    }

    const data = {
      Type: 'all',
    };
    if (this.DateFilter) {
      Object.assign(data, {
        DtEntreeMin: this.DateFilter.DtEntreeMin !== '' ? moment(this.DateFilter.DtEntreeMin).format('YYYY-MM-DD') : '',
        DtEntreeMax: this.DateFilter.DtEntreeMax !== '' ? moment(this.DateFilter.DtEntreeMax).format('YYYY-MM-DD') : '',
      });
    }
    if (this.searchString) {
      Object.assign(data, { key: this.searchString });
    }
  }

  searchWithData(data, setMailActive = false, keepActualTotalCount = false): void {
    this.spinner.show();
    this.isLoading = true;
    this.sourcesService.fetchSources().subscribe({
      next: (response) => {
        this.sourceListLV = [];
        response.forEach((item) => {
          this.sourceListLV.push({
            label: item.description,
            value: item.id,
          });
        });
        if (!keepActualTotalCount) {
          this.getAllMailsCount(data);
        }
        sessionStorage.setItem('searchData', JSON.stringify(data));
        this.mailsService.getAllMails(data, this.sizeChoice).subscribe({
          next: (res) => {
            this.mailsObject = res;
            this.searchParams = data;
            this.mails = [];
            this.searchLoaded = true;
            this.pageNumber = res.pageNumber;

            if (res?.items?.length > 0) {
              // On va commencer par récupérer les expéditeurs de iCourrier
              const sendersiCourrierFromResponse = _.uniq(
                res.items.filter((expediteur) => !!expediteur.expediteurId).map((expediteur) => expediteur.expediteurId)
              );
              const sendersiCourrierFromQuery = data.ExpediteurIds || [];
              const recipientiCourrierFromQuery = data.DestinataireIds || [];
              const listOfExpediteuriCourrierIds = _.uniq([
                ...sendersiCourrierFromResponse,
                ...sendersiCourrierFromQuery,
                ...recipientiCourrierFromQuery,
              ]);

              // Puis on va faire de même avec les expéditeurs de iAdmin
              const sendersiAdminFromResponse = _.uniq(
                res.items.filter((expediteur) => !!expediteur.expediteurIdiAdmin).map((expediteur) => expediteur.expediteurIdiAdmin)
              );
              const sendersiAdminFromQuery = data.ExpediteurIdiAdmins || [];
              const recipientiAdminFromQuery = data.DestinataireIdiAdmins || [];
              const listOfExpediteuriAdminIds = _.uniq([...sendersiAdminFromResponse, ...sendersiAdminFromQuery, ...recipientiAdminFromQuery]);

              forkJoin({
                lowInfoIC: listOfExpediteuriCourrierIds.length
                  ? this.getLowInformationsContactIds(listOfExpediteuriCourrierIds, 'getLowInformationsContactsiCourrier')
                  : of([]),
                lowInfosIAdmin: listOfExpediteuriAdminIds.length
                  ? this.getLowInformationsContactIds(listOfExpediteuriAdminIds, 'getLowInformationsContactsiAdmin')
                  : of([]),
              }).subscribe((value) => {
                this.contacts = value.lowInfoIC.map((expediteur) => new Contact(expediteur));
                this.contactsiAdmin = value.lowInfosIAdmin.map((expediteur) => new Contact(expediteur));
                res.items.forEach((mail) => {
                  let mailFullInfo = new Mail(mail);
                  if (mailFullInfo.statutId && this.globalStatus.length > 0) {
                    mailFullInfo = this.setMailStatus(mailFullInfo);
                  }
                  if (mailFullInfo.sourceId && this.sourceListLV.length > 0) {
                    mailFullInfo = this.setMailSource(mailFullInfo);
                  }

                  if (mailFullInfo.expediteurId) {
                    const foundSender = this.contacts.find((contact) => contact.id === mailFullInfo.expediteurId);
                    if (foundSender) {
                      mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                    }
                  } else if (mailFullInfo.expediteurIdiAdmin) {
                    const foundSender = this.contactsiAdmin.find((contact) => contact.id === mailFullInfo.expediteurIdiAdmin);
                    if (foundSender) {
                      mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                    }
                  }
                  this.mails.push(mailFullInfo);
                });
                this.getColumns();
                this.isLoading = false;
                if (sessionStorage.getItem('filter-type')) {
                  this.typeEntrantSortant = sessionStorage.getItem('filter-type');
                }
                if (setMailActive) {
                  this.getMailActive(this.mails[0].id);
                } else {
                  this.spinner.hide();
                }
              });
            } else {
              this.spinner.hide();
              this.isLoading = false;
              this.mails = [];
            }
          },
          error: (err) => {
            console.error(err);
            this.spinner.hide();
            this.isLoading = false;
            this.mails = [];
            this.toastr.error(this.translater.translate('errorOccurredWhenRecoveringDatas'));
          },
        });
      },
    });
  }

  paginate(pageNumber): void {
    const data = JSON.parse(sessionStorage.getItem('searchData'));

    data.PageNumber = pageNumber;
    data.CalcTotal = false;
    this.searchWithData(data, false, true);
  }

  changeSize(): void {
    const data = JSON.parse(sessionStorage.getItem('searchData'));

    data.PageNumber = 1;
    data.CalcTotal = false;
    this.searchWithData(data, false, true);
  }

  public receiveItem(event: { obj: Mail }): void {
    this.getMailActive(event.obj.id);
  }

  public openMail(): void {
    /* This is needed for this.superListTools to work. Don't ask me why I have no clue. I just remember that once I deleted it and broke it... so for now I keep it here. If you do have the time to check it, feel free to do so. It's surely just the <app-super-list-new-visual> that needs a little fix.*/
  }

  getMailsParams(title: string): void {
    if (this.advancedSearchDatas === null) {
      let data = {};
      if (title) {
        switch (title) {
          case 'Tous les courriers':
            data = {
              Tag: 'All',
            };
            sessionStorage.setItem('Tag', 'All');
            this.spinner.show();
            this.getMails(data, 'all');
            break;
          case 'Tous les entrants':
            data = {
              Type: 'Entrant',
            };
            sessionStorage.setItem('Tag', 'Entrant');
            this.getMails(data, 'entrants');
            break;
          case 'Tous les sortants':
            data = {
              Type: 'Sortant',
            };
            sessionStorage.setItem('Tag', 'Sortant');
            this.getMails(data, 'sortants');
            break;
          case 'Tous les internes':
            data = {
              Type: 'Interne',
            };
            sessionStorage.setItem('Tag', 'Interne');
            this.getMails(data, 'internes');
            break;
          case 'Non lu(s)':
            data = {
              Tag: 'NonLus',
            };
            sessionStorage.setItem('Tag', 'NonLus');
            this.getMails(data, 'nonLus');
            break;
          case 'Lu(s)':
            data = {
              Tag: 'Lus',
            };
            sessionStorage.setItem('Tag', 'Lus');
            this.getMails(data, 'Lus');
            break;
          case 'Prise en charge pour mon service':
            data = {
              Tag: 'APrendreEnCharge',
            };
            sessionStorage.setItem('Tag', 'APrendreEnCharge');
            this.getMails(data, 'aPrendreEnCharge');
            break;
          case 'Demandes non prises en charge par mon service':
            data = {
              Tag: 'NonPrisEnCharge',
            };
            sessionStorage.setItem('Tag', 'NonPrisEnCharge');
            this.getMails(data, 'NonPrisEnCharge');
            break;
          case 'Mal routé(s)':
            data = {
              Tag: 'MalRoutes',
            };
            sessionStorage.setItem('Tag', 'MalRoutes');
            this.getMails(data, 'MalRoutes');
            break;
          case 'Courriers entrants à valider':
            data = {
              Tag: 'AValider',
              Type: 'E',
            };
            sessionStorage.setItem('Tag', 'AValider');
            this.getMails(data, 'AValider');
            break;
          case 'A distribuer':
            data = {
              Tag: 'ADistribuer',
            };
            sessionStorage.setItem('Tag', 'ADistribuer');
            this.getMails(data, 'ADistribuer');
            break;
          case 'A valider':
            data = {
              Tag: 'AValider',
              Type: 'E',
            };
            sessionStorage.setItem('Tag', 'AValider');
            this.getMails(data, 'AValider');
            break;
          case 'A compléter':
            data = {
              Tag: 'ACompleter',
            };
            sessionStorage.setItem('Tag', 'ACompleter');
            this.getMails(data, 'ACompleter');
            break;
          case 'bacs':
            data = {
              BacIds: localStorage.getItem('bacsIds'),
            };
            this.getMails(data, '');
            this.selected = null;
            break;
          case 'Pour information':
            data = {
              Tag: 'PourInfo',
            };
            sessionStorage.setItem('Tag', 'PourInfo');
            this.getMails(data, 'PourInfo');
            break;
          case 'Epinglé(s)':
            data = {
              Tag: 'Epingles',
            };
            sessionStorage.setItem('Tag', 'Epingles');
            this.getMails(data, 'epingles');
            break;

          case 'Prise en charge demandée par mon service':
            data = {
              Tag: 'PrisEnCharge',
            };
            sessionStorage.setItem('Tag', 'PrisEnCharge');
            this.getMails(data, 'prisEnCharge');
            break;
          case 'Pour action':
            data = {
              Tag: 'PourAction',
            };
            sessionStorage.setItem('Tag', 'PourAction');
            this.getMails(data, 'pourAction');
            break;
          case 'Récemment consulté(s)':
            data = {
              DtConsultMin: moment().subtract(1, 'weeks').format('YYYY-MM-DD'),
            };
            this.getMails(data, 'recemmentConsultes');
            break;
          case 'Récemment créé(s)':
            data = {
              DtEntreeMin: moment().subtract(1, 'weeks').format('YYYY-MM-DD'),
            };
            this.getMails(data, 'recemmentCrees');
            break;
          case 'Courrier à classer':
            data = {
              Tag: 'AClasser',
            };
            sessionStorage.setItem('Tag', 'AClasser');
            this.getMails(data, 'AClasser');
            break;
          default:
            data = {};
            sessionStorage.setItem('Tag', 'All');
            this.getMails(data, 'all');
            break;
        }
      } else {
        data = {
          Tag: 'All',
        };
        this.spinner.show();
        this.getMails(data, 'all');
      }
    } else {
      //si on est dans la recherche avancée
      this.searchMailAdvancedSearch(true);
    }
  }

  getMailById(id): void {
    // !! Vérifiez bien que quand on appelle getMailById que l'on soit dans une recherche avancée OU sauvegardée!!! sinon on set this.advancedSearchArray et ca va foutre le boxon :)
    this.mailsService.fetchMailsById(id).subscribe({
      next: (response: MailDTO) => {
        if (response) {
          let mailResponse = new Mail(response);
          this.mails = [];
          this.searchLoaded = true;
          this.pageNumber = 1;
          this.numberCourrier = 1;
          if (mailResponse.statutId && this.globalStatus?.length > 0) {
            mailResponse = this.setMailStatus(mailResponse);
          }
          if (mailResponse.sourceId && this.sourceListLV?.length > 0) {
            mailResponse = this.setMailSource(mailResponse);
          }

          this.setExpediteur(mailResponse).then((mail) => {
            mailResponse = new Mail(mail);
            this.manageMail(mailResponse);
            this.advancedSearchArray = [{ label: 'Id', value: this.advancedSearchDatas.Id }];
          });
        } else {
          this.spinner.hide();
          this.isLoading = false;
          this.mails = [];
        }
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
        this.spinner.hide();
        this.mails = [];
      },
    });
  }

  getMails(data: MailsMeSearchParams, title: string): Promise<boolean> {
    return new Promise((resolve) => {
      title ? (this.title = title) : null;
      this.spinner.show();
      this.isLoading = true;
      this.mails = [];

      const dataToSave = {
        ...data,
        CalcTotal: false,
      };
      sessionStorage.setItem('searchData', JSON.stringify(dataToSave));
      this.getAllMailsCount(data);

      this.mailsService.getAllMails(dataToSave, this.sizeChoice).subscribe({
        next: (response) => {
          this.mailsObject = response;
          this.mails = [];
          this.pageNumber = response.pageNumber;

          if (response?.items?.length > 0) {
            // On va commencer par récupérer les expéditeurs de iCourrier
            const sendersiCourrierFromResponse = _.uniq(
              response.items.filter((expediteur) => !!expediteur.expediteurId).map((expediteur) => expediteur.expediteurId)
            );
            const sendersiCourrierFromQuery = data.ExpediteurIds || [];
            const recipientiCourrierFromQuery = data.DestinataireIds || [];
            const listOfExpediteuriCourrierIds = _.uniq([
              ...sendersiCourrierFromResponse,
              ...sendersiCourrierFromQuery,
              ...recipientiCourrierFromQuery,
            ]);

            // Puis on va faire de même avec les expéditeurs de iAdmin
            const sendersiAdminFromResponse = _.uniq(
              response.items.filter((expediteur) => !!expediteur.expediteurIdiAdmin).map((expediteur) => expediteur.expediteurIdiAdmin)
            );
            const sendersiAdminFromQuery = data.ExpediteurIdiAdmins || [];
            const recipientiAdminFromQuery = data.DestinataireIdiAdmins || [];
            const listOfExpediteuriAdminIds = _.uniq([...sendersiAdminFromResponse, ...sendersiAdminFromQuery, ...recipientiAdminFromQuery]);

            forkJoin({
              lowInfoIC: listOfExpediteuriCourrierIds.length
                ? this.getLowInformationsContactIds(listOfExpediteuriCourrierIds, 'getLowInformationsContactsiCourrier')
                : of([]),
              lowInfosIAdmin: listOfExpediteuriAdminIds.length
                ? this.getLowInformationsContactIds(listOfExpediteuriAdminIds, 'getLowInformationsContactsiAdmin')
                : of([]),
              classificationLookupMaps: this.classificationsService.getClassificationLookupMaps().pipe(catchError(() => of(null))),
            }).subscribe((value) => {
              this.contacts = value.lowInfoIC.map((expediteur) => new Contact(expediteur));
              this.contactsiAdmin = value.lowInfosIAdmin.map((expediteur) => new Contact(expediteur));

              response.items.forEach((mail) => {
                let mailFullInfo = new Mail(mail);
                if (mailFullInfo.statutId && this.globalStatus.length > 0) {
                  mailFullInfo = this.setMailStatus(mailFullInfo);
                }
                if (mailFullInfo.sourceId && this.sourceListLV.length > 0) {
                  mailFullInfo = this.setMailSource(mailFullInfo);
                }
                if (value.classificationLookupMaps) {
                  if (!mailFullInfo.classementCode && mailFullInfo.classementId) {
                    mailFullInfo.classementCode = value.classificationLookupMaps.classementMap.get(mailFullInfo.classementId);
                  }
                  if (!mailFullInfo.classeurDescription && mailFullInfo.classeurId) {
                    mailFullInfo.classeurDescription = value.classificationLookupMaps.classeurMap.get(mailFullInfo.classeurId);
                  }
                  if (!mailFullInfo.chemiseDescription && mailFullInfo.chemiseId) {
                    mailFullInfo.chemiseDescription = value.classificationLookupMaps.chemiseMap.get(mailFullInfo.chemiseId);
                  }
                }
                if (mailFullInfo.expediteurId) {
                  const foundSender = this.contacts.find((contact) => contact.id === mailFullInfo.expediteurId);
                  if (foundSender) {
                    mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                  }
                } else if (mailFullInfo.expediteurIdiAdmin) {
                  const foundSender = this.contactsiAdmin.find((contact) => contact.id === mailFullInfo.expediteurIdiAdmin);
                  if (foundSender) {
                    mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                  }
                }
                this.mails.push(mailFullInfo);
              });
              this.getColumns();

              const IDurl = location.pathname.split('/').slice(-1)[0];
              this.idMailActive = +IDurl;
              if (this.idMailActive === null || (Number.isNaN(this.idMailActive) && this.mails.length > 0)) {
                // NO ID ON THE ROAD SO PICTURE
                this.welcomeMode = true;
              } else {
                this.mailActive = this.mails.find((x) => x.id === +this.idMailActive);
                if (this.mailActive) {
                  this.mailActive.active = true;
                }
              }

              this.dataService.setMailActive(this.mailActive); // emit to ficheForm and courrierFicheHeader
              this.spinner.hide();
              resolve(true);
              this.isLoading = false;
            });
          } else {
            this.getColumns();
            const IDurl = location.pathname.split('/').slice(-1)[0];
            this.idMailActive = +IDurl;
            if (this.idMailActive === null || (Number.isNaN(this.idMailActive) && this.mails.length > 0)) {
              // NO ID ON THE ROAD SO PICTURE
              this.welcomeMode = true;
            } else {
              this.mailActive = this.mails.find((x) => x.id === +this.idMailActive);
              if (this.mailActive) {
                this.mailActive.active = true;
              }
            }
            this.dataService.setMailActive(this.mailActive); // emit to ficheForm and courrierFicheHeader
            this.isLoading = false;
            this.spinner.hide();
            this.mails = [];
            resolve(true);
          }
        },
        error: (error) => {
          console.error('Error : ', error);
          this.isLoading = false;
          this.spinner.hide();
          this.mails = [];
          this.toastr.error(this.translater.translate('errorOccurredWhenRecoveringDatas'));
        },
      });
    });
  }

  getLocksAccess(courrierID: number): void {
    this.mailsLockUnlockService.getLockInfo(courrierID).subscribe({
      next: (res) => {
        const currentUserLockInfo: MailLockEntryDTO = _.last(res.filter((x) => x.contactId === this.userInfos?.contactId));
        this.lock(courrierID, currentUserLockInfo ? currentUserLockInfo.version + 1 : 1);
      },
    });
  }

  lock(courrierID: number, version = 1, type = 'Read'): Promise<boolean> {
    return new Promise((resolve) => {
      this.mailsLockUnlockService.postLockUnlock(courrierID, type, version).subscribe({
        next: () => {
          if (type === 'Write') {
            this.toastr.success('Le courrier est verrouillé');
          } else {
            this.toastr.success('Le courrier est déverrouillé');
          }
          resolve(true);
        },
      });
    });
  }

  getMailActive(id: number): void {
    this.welcomeMode = false;
    this.mailActive = this.mails.find((m) => m.id === id);

    if (this.mailActive) {
      this.getLocksAccess(this.mailActive.id);
      this.titleService.setTitle(this.translater.translate('tabsTitle.id', { id: this.mailActive.id.toString() }));
    } else {
      this.titleService.setTitle('iCourrier');
    }

    if (this.mailActive && !this.mailActive.active) {
      this.mailActive.active = true;
    }
    let url = '';
    if (this.advancedSearchDatas !== null) {
      sessionStorage.setItem('searchData', JSON.stringify(this.advancedSearchDatas));

      let queryParams = Object.keys(this.advancedSearchDatas)
        .filter((key) => key !== 'NatureCustomFieldsSearch')
        .map((key) => {
          if (_.isArray(this.advancedSearchDatas[key])) {
            return `${key}=${this.advancedSearchDatas[key].toString()}`;
          } else {
            return `${key}=${this.advancedSearchDatas[key]}`;
          }
        })
        .join('&');

      if ((this.advancedSearchDatas.NatureCustomFieldsSearch as [MailDetailsCustomNatureDataDto])?.length) {
        (this.advancedSearchDatas.NatureCustomFieldsSearch as MailDetailsCustomNatureDataDto[]).forEach((natureCustom) => {
          switch (natureCustom.type) {
            case 'text':
              queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.textValue)}`;
              break;
            case 'date':
              queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.dateValue)}`;
              break;
            case 'checkbox':
              queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.numberValue)}`;
              break;
            case 'decimal':
              queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.decimalValue)}`;
              break;
            case 'integer':
              queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.numberValue)}`;
              break;
            case 'textarea':
              queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.textValue)}`;
              break;
            case 'dropdown':
              queryParams += `&NCFS_${natureCustom.natureCustomFieldId}=${encodeURIComponent(natureCustom.listValueItemId)}`;
              break;
          }
        });
      }

      url = this.router.serializeUrl(
        this.router.createUrlTree(['/private/ic/courriers/advancedSearch/' + this.mailActive?.id], {
          queryParams: {
            advancedSearchData: queryParams,
          },
        })
      );
    } else {
      url = '/private/ic/courriers/' + this.slugUrl + '/' + this.mailActive?.id;
    }
    if (this.mailActive) {
      this.router.navigateByUrl(url);
    }
    this.spinner.hide();
  }

  markAsReaded(id: number): void {
    const data = {
      mailIds: [id],
    };
    this.mailsService.markAsReaded(data).subscribe({
      next: () => {
        this.mailActive?.setStatusColorClass();
        if (this.selected && this.selected.includes('Non-lus')) {
          const notReadBox = this.boxes.find((b) => b.title === 'Non-lus');
          notReadBox.count = +notReadBox.count - 1;
        }
      },
      error: (error) => {
        console.error(error);
        this.toastr.error(this.translater.translate('homeCourrierChild.noRightToPutRead'));
      },
    });
  }
  markAsReadedMultiple(selections): void {
    const listOfIds = {
      mailIds: [],
    };
    selections.map((item) => {
      listOfIds.mailIds.push(item.id);
    });
    this.mailsService.markAsReaded(listOfIds).subscribe({
      next: () => {
        this.toastr.success(this.translater.translate('homeCourrierChild.courriersMarkedAsRead'));
        if (this.mailActive?.id && listOfIds.mailIds.indexOf(this.mailActive?.id) > -1) this.mailActive.setStatusColorClass();

        let keepActualTotalCount = true;

        if (this.currentTag && this.currentTag === 'nonLus') {
          const notReadBox = this.boxes.find((b) => b.name === this.currentTag);
          notReadBox.count = +notReadBox.count - listOfIds.mailIds.length;
          keepActualTotalCount = false;
        }
        const data = {
          ...JSON.parse(sessionStorage.getItem('searchData')),
          CalcTotal: false,
        };
        this.searchWithData(data, true, keepActualTotalCount);
      },
      error: (error) => {
        console.error(error);
        this.toastr.error(this.translater.translate('homeCourrierChild.noRightToPutRead'));
      },
    });
  }

  onChange(event): void {
    this.sizeChoice = 50;
    this.title = event.value;
    const currentBox = this.boxes.filter((x) => x.title === this.title);
    this.currentTag = currentBox[0].name;
    this.selected = this.title;
    localStorage.removeItem('activeCategoryCourrier');
    sessionStorage.removeItem('searchData');
    this.resetSelectedItems = true;
    if (currentBox.length > 0) {
      localStorage.setItem('activeCategoryCourrier', currentBox[0].name);
      this.router.navigateByUrl('/private/ic/courriers/' + currentBox[0].name);
    }
  }

  private setBoxNameAndCount(
    boxChosen: {
      name: string;
      count: number;
      menu: string;
      title: string;
      icon: string;
      iconColor: string;
      click: () => void;
    },
    count?: number
  ): void {
    this.selected = boxChosen?.title !== null ? boxChosen.title : 'Tous les courriers';
    if (count) {
      boxChosen.count = count;
    }
  }

  removeDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
  }

  receiveNewMail(mail: Mail): void {
    this.newMailActive = mail;
  }

  checkDataService(): void {
    this.dataService.getMailGlob().subscribe({
      next: (mail: MailInsert) => {
        if (mail) {
          this.mailActive = new Mail(mail);
          this.chgActiveMailSubject.next(this.mailActive);
        }
      },
    });
  }

  showMore(data: MailsMeSearchParams): void {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (value === null) {
        delete data[key];
      }
    });
    data = {
      ...data,
      CalcTotal: false,
    };
    this.mailsService.getAllMails(data, this.sizeChoice).subscribe({
      next: (response) => {
        this.pageNumber = response.pageNumber;
        this.mailsObject.pageNumber = response.pageNumber;
        this.mailsObject.totalPages = response.totalPages;

        // On va commencer par récupérer les expéditeurs de iCourrier
        const sendersiCourrierFromResponse = _.uniq(
          response.items.filter((expediteur) => !!expediteur.expediteurId).map((expediteur) => expediteur.expediteurId)
        );
        const sendersiCourrierFromQuery = data.ExpediteurIds || [];
        const recipientiCourrierFromQuery = data.DestinataireIds || [];
        const listOfExpediteuriCourrierIds = _.uniq([...sendersiCourrierFromResponse, ...sendersiCourrierFromQuery, ...recipientiCourrierFromQuery]);

        // Puis on va faire de même avec les expéditeurs de iAdmin
        const sendersiAdminFromResponse = _.uniq(
          response.items.filter((expediteur) => !!expediteur.expediteurIdiAdmin).map((expediteur) => expediteur.expediteurIdiAdmin)
        );
        const sendersiAdminFromQuery = data.ExpediteurIdiAdmins || [];
        const recipientiAdminFromQuery = data.DestinataireIdiAdmins || [];
        const listOfExpediteuriAdminIds = _.uniq([...sendersiAdminFromResponse, ...sendersiAdminFromQuery, ...recipientiAdminFromQuery]);

        forkJoin({
          lowInfoIC: listOfExpediteuriCourrierIds.length
            ? this.getLowInformationsContactIds(listOfExpediteuriCourrierIds, 'getLowInformationsContactsiCourrier')
            : of([]),
          lowInfosIAdmin: listOfExpediteuriAdminIds.length
            ? this.getLowInformationsContactIds(listOfExpediteuriAdminIds, 'getLowInformationsContactsiAdmin')
            : of([]),
        }).subscribe((value) => {
          this.contacts = value.lowInfoIC.map((expediteur) => new Contact(expediteur));
          this.contactsiAdmin = value.lowInfosIAdmin.map((expediteur) => new Contact(expediteur));

          const temp = [];
          if (response?.items?.length > 0) {
            response.items.forEach((mail) => {
              let mailFullInfo = new Mail(mail);
              if (mailFullInfo.statutId && this.globalStatus.length > 0) {
                mailFullInfo = this.setMailStatus(mailFullInfo);
              }
              if (mailFullInfo.sourceId && this.sourceListLV.length > 0) {
                mailFullInfo = this.setMailSource(mailFullInfo);
              }
              if (mailFullInfo.expediteurId) {
                const foundSender = this.contacts.find((contact) => contact.id === mailFullInfo.expediteurId);
                if (foundSender) {
                  mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                }
              } else if (mailFullInfo.expediteurIdiAdmin) {
                const foundSender = this.contactsiAdmin.find((contact) => contact.id === mailFullInfo.expediteurIdiAdmin);
                if (foundSender) {
                  mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                }
              }
              temp.push(mailFullInfo);
            });

            let array_to_be_uniq = [];
            array_to_be_uniq = this.mails.concat(temp);
            this.mails = [...array_to_be_uniq];
            this.spinner.hide();
            this.getColumns();
          }
        });
      },
      error: (err) => {
        console.error(err);
        this.spinner.hide();
        this.isLoading = false;
        this.mails = [];
        this.toastr.error(this.translater.translate('errorOccurredWhenRecoveringDatas'));
      },
    });
  }

  searchMailInReinitVersion(event): void {
    event.preventDefault(); // sert à empêcher l'ajout du passage à la ligne dans le texte
    event.stopPropagation(); // sert à empêcher l'ajout du passage à la ligne dans le texte
    this.searchMail();
  }

  onSearchButtonClick(): void {
    if (this.dropdownValue !== 'Services' && this.searchString && this.searchString !== '') {
      //ne pas faire une recherche à vide
      this.searchMail();
    } else {
      if (this.searchString === null || this.searchString === '') {
        this.reset();
      }
    }
  }

  searchMail(listOfServices?: Array<number>): void {
    if ((this.searchString === null || this.searchString === '') && listOfServices?.length === 0) {
      //Si l'input est null, on reset
      this.reset();
    } else {
      this.spinner.show();
      let data = {
        key: null,
        Objet: null,
        Id: null,
        SvcPropIds: null,
        Type: 'all',
        Tag: 'all',
        DtEntreeMin: '',
        DtEntreeMax: '',
        DtConsultMin: '',
      };
      if (this.DateFilter && this.DateFilter.DtEntreeMin !== '' && this.DateFilter.DtEntreeMax !== '') {
        data = {
          key: null,
          Objet: null,
          Id: null,
          SvcPropIds: null,
          Type: 'all',
          Tag: 'all',
          DtEntreeMin: this.DateFilter.DtEntreeMin !== '' ? moment(this.DateFilter.DtEntreeMin).format('YYYY-MM-DD') : '',
          DtEntreeMax: this.DateFilter.DtEntreeMax !== '' ? moment(this.DateFilter.DtEntreeMax).format('YYYY-MM-DD') : '',
          DtConsultMin: '',
        };
      }
      this.searchLoaded = false;
      const type = localStorage.getItem('activeCategoryCourrier').toLowerCase();
      if (type === 'recemmentcrees') {
        delete data.DtConsultMin;
        delete data.Tag;
        delete data.DtEntreeMax;
        delete data.Type;
        data.DtEntreeMin = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
      } else if (type === 'recemmentconsultes') {
        delete data.Tag;
        delete data.DtEntreeMax;
        delete data.Type;
        delete data.DtEntreeMin;
        data.DtConsultMin = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
      } else if (type !== 'lus') {
        data.Tag = type ? String(type).charAt(0).toUpperCase() + String(type).slice(1).toLowerCase() : 'All';
      } else {
        data.Tag = 'all';
      }
      if (type === 'entrants' || type === 'sortants' || type === 'all' || type === 'internes') {
        if (type === 'entrants') {
          data.Type = 'E';
          delete data.Tag;
        }
        if (type === 'sortants') {
          data.Type = 'S';
          delete data.Tag;
        }
        if (type === 'internes') {
          data.Type = 'I';
          delete data.Tag;
        }
      }
      this.flagStoppingTheRequest = false;
      if (this.dropdownValue === 'Recherche basique') {
        data.key = this.searchString;
        delete data.Objet;
        delete data.Id;
        delete data.SvcPropIds;
      } else if (this.dropdownValue === 'Objet') {
        delete data.key;
        data.Objet = this.searchString;
        delete data.Id;
        delete data.SvcPropIds;
      } else if (this.dropdownValue === 'Id') {
        delete data.key;
        delete data.Objet;
        data.Id = this.searchString;
        delete data.SvcPropIds;

        //We will check if the searchString is really a number. if not it will trigger a flag to display the error
        if (Number.isNaN(+data.Id)) {
          this.flagStoppingTheRequest = true;
          this.flagStoppingTheRequestId = data.Id;
        }
      } else if (this.dropdownValue === 'Services') {
        delete data.key;
        delete data.Objet;
        delete data.Id;
        data.SvcPropIds = listOfServices;
      }
      if (data.key === null) {
        delete data.key;
      }
      if (data.Objet === null) {
        delete data.Objet;
      }
      if (data.Id === null) {
        delete data.Id;
      }
      if (data.SvcPropIds === null) {
        delete data.SvcPropIds;
      }
      if (data.Type === null) {
        delete data.Type;
      }
      if (data.DtEntreeMin === '') {
        delete data.DtEntreeMin;
      }
      if (data.DtEntreeMax === '') {
        delete data.DtEntreeMax;
      }
      if (data.DtConsultMin === '') {
        delete data.DtConsultMin;
      }

      if (this.flagStoppingTheRequest) {
        this.numberCourrier = 0;
        this.mails = [];
        this.toastr.error(this.translater.translate('homeCourrierChild.searchErrorWithId', { id: this.searchString }));
        this.spinner.hide();
        return;
      }

      if (data.key) data.key = encodeURIComponent(data.key);
      if (data.Objet) data.Objet = encodeURIComponent(data.Objet);
      if (data.Id) data.Id = encodeURIComponent(data.Id);

      sessionStorage.setItem('searchData', JSON.stringify(data));
      const dataNoCount = {
        ...data,
        CalcTotal: false,
      };

      this.getAllMailsCount(data);

      this.mailsService.getAllMails(dataNoCount, this.sizeChoice).subscribe({
        next: (res) => {
          this.searchParams = data;
          this.mails = [];
          this.searchLoaded = true;
          this.pageNumber = 1;
          this.mailsObject = res;

          if (res?.items?.length > 0) {
            // On va commencer par récupérer les expéditeurs de iCourrier
            const sendersiCourrierFromResponse = _.uniq(
              res.items.filter((expediteur) => !!expediteur.expediteurId).map((expediteur) => expediteur.expediteurId)
            );
            const listOfExpediteuriCourrierIds = _.uniq([...sendersiCourrierFromResponse]);

            // Puis on va faire de même avec les expéditeurs de iAdmin
            const sendersiAdminFromResponse = _.uniq(
              res.items.filter((expediteur) => !!expediteur.expediteurIdiAdmin).map((expediteur) => expediteur.expediteurIdiAdmin)
            );
            const listOfExpediteuriAdminIds = _.uniq([...sendersiAdminFromResponse]);

            forkJoin({
              lowInfoIC: listOfExpediteuriCourrierIds.length
                ? this.getLowInformationsContactIds(listOfExpediteuriCourrierIds, 'getLowInformationsContactsiCourrier')
                : of([]),
              lowInfosIAdmin: listOfExpediteuriAdminIds.length
                ? this.getLowInformationsContactIds(listOfExpediteuriAdminIds, 'getLowInformationsContactsiAdmin')
                : of([]),
            }).subscribe((value) => {
              this.contacts = value.lowInfoIC.map((expediteur) => new Contact(expediteur));
              this.contactsiAdmin = value.lowInfosIAdmin.map((expediteur) => new Contact(expediteur));

              res.items.forEach((mail) => {
                let mailFullInfo = new Mail(mail);
                if (mailFullInfo.statutId && this.globalStatus.length > 0) {
                  mailFullInfo = this.setMailStatus(mailFullInfo);
                }
                if (mailFullInfo.sourceId && this.sourceListLV.length > 0) {
                  mailFullInfo = this.setMailSource(mailFullInfo);
                }
                if (mailFullInfo.expediteurId) {
                  const foundSender = this.contacts.find((contact) => contact.id === mailFullInfo.expediteurId);
                  if (foundSender) {
                    mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                  }
                } else if (mailFullInfo.expediteurIdiAdmin) {
                  const foundSender = this.contactsiAdmin.find((contact) => contact.id === mailFullInfo.expediteurIdiAdmin);
                  if (foundSender) {
                    mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                  }
                }
                this.mails.push(mailFullInfo);
              });
              this.getColumns();

              const tempMailActive = this.mails.find((m) => m.id === this.mailActive?.id);
              if (tempMailActive) {
                this.getMailActive(this.mailActive.id);
              } else {
                this.getMailActive(this.mails[0]?.id);
              }
            });
          } else {
            this.spinner.hide();
            this.isLoading = false;
            this.mails = [];
          }
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
          this.isLoading = false;
          this.mails = [];
          this.toastr.error(this.translater.translate('errorOccurredWhenRecoveringDatas'));
        },
      });
    }
  }

  searchMailAdvancedSearch(doNotResetMailsList = false, keepActualTotalCount = false): void {
    doNotResetMailsList ? '' : (this.mails = []);
    const data: {
      [key: string]: unknown;
    } = { ...this.advancedSearchDatas, CalcTotal: false };
    if (this.inputDisplayOnAdvancedSearch !== null || this.inputDisplayOnAdvancedSearch !== '') {
      data.key = encodeURIComponent(this.inputDisplayOnAdvancedSearch);
    }
    sessionStorage.setItem('searchData', JSON.stringify(data));
    if (!keepActualTotalCount) {
      this.getAllMailsCount(data);
    }
    this.mailsService.getAllMails(data, this.sizeChoice).subscribe({
      next: (res) => {
        doNotResetMailsList ? '' : (this.mails = []);
        this.searchLoaded = true;
        this.pageNumber = res.pageNumber;
        if (res?.items?.length > 0) {
          // On va commencer par récupérer les expéditeurs de iCourrier
          const sendersiCourrierFromResponse = _.uniq(
            res.items.filter((expediteur) => !!expediteur.expediteurId).map((expediteur) => expediteur.expediteurId)
          );
          const sendersiCourrierFromQuery = (data.ExpediteurIds as number[]) || [];
          const recipientiCourrierFromQuery = (data.DestinataireIds as number[]) || [];
          const listOfExpediteuriCourrierIds = _.uniq([
            ...sendersiCourrierFromResponse,
            ...sendersiCourrierFromQuery,
            ...recipientiCourrierFromQuery,
          ]);

          // Puis on va faire de même avec les expéditeurs de iAdmin
          const sendersiAdminFromResponse = _.uniq(
            res.items.filter((expediteur) => !!expediteur.expediteurIdiAdmin).map((expediteur) => expediteur.expediteurIdiAdmin)
          );
          const sendersiAdminFromQuery = (data.ExpediteurIdiAdmins as number[]) || [];
          const recipientiAdminFromQuery = (data.DestinataireIdiAdmins as number[]) || [];
          const listOfExpediteuriAdminIds = _.uniq([...sendersiAdminFromResponse, ...sendersiAdminFromQuery, ...recipientiAdminFromQuery]);

          forkJoin({
            lowInfoIC: listOfExpediteuriCourrierIds.length
              ? this.getLowInformationsContactIds(listOfExpediteuriCourrierIds, 'getLowInformationsContactsiCourrier')
              : of([]),
            lowInfosIAdmin: listOfExpediteuriAdminIds.length
              ? this.getLowInformationsContactIds(listOfExpediteuriAdminIds, 'getLowInformationsContactsiAdmin')
              : of([]),
          }).subscribe((value) => {
            this.contacts = value.lowInfoIC.map((expediteur) => new Contact(expediteur));
            this.contactsiAdmin = value.lowInfosIAdmin.map((expediteur) => new Contact(expediteur));

            res.items.forEach((mail) => {
              let mailFullInfo = new Mail(mail);
              if (mailFullInfo.statutId && this.globalStatus.length > 0) {
                mailFullInfo = this.setMailStatus(mailFullInfo);
              }
              if (mailFullInfo.sourceId && this.sourceListLV.length > 0) {
                mailFullInfo = this.setMailSource(mailFullInfo);
              }
              if (mailFullInfo.expediteurId) {
                const foundSender = this.contacts.find((contact) => contact.id === mailFullInfo.expediteurId);
                if (foundSender) {
                  mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                }
              } else if (mailFullInfo.expediteurIdiAdmin) {
                const foundSender = this.contactsiAdmin.find((contact) => contact.id === mailFullInfo.expediteurIdiAdmin);
                if (foundSender) {
                  mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                }
              }

              this.mails.push(mailFullInfo);
            });

            const tempMailActive = this.mails.find((m) => m.id === this.mailActive?.id);
            if (tempMailActive) {
              this.getMailActive(this.mailActive.id);
            } else {
              this.getMailActive(this.mails[0]?.id);
            }
          });
        } else {
          this.spinner.hide();
          this.isLoading = false;
          this.mails = [];
        }
      },
      error: (err) => {
        console.error(err);
        this.spinner.hide();
        this.isLoading = false;
        this.mails = [];
        this.toastr.error(this.translater.translate('errorOccurredWhenRecoveringDatas'));
      },
    });
  }

  openMailTypeModal(): void {
    const ref = this.dialogService.open(MailTypeModalComponent, {
      styleClass: 'super-compos-modal-content',
      dismissableMask: false,
      width: '70vw',
      closable: true,
      header: 'Type de courrier',
      baseZIndex: 1000,
    });
    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          this.openCourrierCreateModal(value);
        }
      },
    });
  }

  openCourrierCreateModal(mailType: string): void {
    const data: MailInfosViaExtraStateRouter = {
      mailType: mailType,
      mailMode: 'edit',
      isAnswerMode: false,
      isNew: true,
    };
    this.router.navigate(['/private/ic/new'], { state: data });
  }

  reset(): void {
    this.searchString = '';
    this.dropdownLabel = this.translater.translate('homeCourrierChild.basicSearch');
    this.dropdownValue = 'Recherche basique';
    this.activeModeSearch = 'normalSearch';
    this.inputDisplayOnServiceSearch = '';
    this.inputDisplayOnServiceSearchTooltip = '';
    this.selectedOption = [];
    sessionStorage.removeItem('searchData');
    sessionStorage.removeItem('filter-search');
    sessionStorage.removeItem('reloadData');
    sessionStorage.removeItem('advancedSearch');
    this.formSearch.reset();
    this.hasAdvancedSearch = false;
    this.advancedSearchArray = [];
    this.advancedSearchDatas = null;
    delete window['advancedSearchDatas'];
    this.searchFull('reset');
  }

  resetAdvancedSearch(): void {
    this.inputDisplayOnAdvancedSearch = '';
    this.advancedSearchDatas.key = null;
    this.searchMailAdvancedSearch();
  }

  resetServiceModal(): void {
    this.dropdownLabel = this.translater.translate('homeCourrierChild.basicSearch');
    this.dropdownValue = 'Recherche basique';
    this.activeModeSearch = 'normalSearch';
    this.inputDisplayOnServiceSearch = '';
    this.inputDisplayOnServiceSearchTooltip = '';
    this.selectedOption = [];
    this.openModalTreeServicesSelection = false;
  }
  resetFull(): void {
    this.searchString = '';
    sessionStorage.removeItem('searchData');
    sessionStorage.removeItem('filter-search');
    sessionStorage.removeItem('reloadData');
    sessionStorage.removeItem('advancedSearch');
    this.formSearch.reset();
  }

  getOppositeColor(bgColor): string {
    if (bgColor) {
      const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      const r = parseInt(color.substring(0, 2), 16); // hexToR
      const g = parseInt(color.substring(2, 4), 16); // hexToG
      const b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
  }

  subscribeToRefresh(): void {
    this.dataService.getRefreshList().subscribe({
      next: (response) => {
        if (response === true) {
          this.getMailsParams(this.title);
        }
      },
    });
  }

  advancedSearchs(): void {
    forkJoin({
      tags: this.multipleStatutesService.getMultipleStatus().pipe(
        catchError(() => {
          this.toastr.error(this.translater.translate('error.errorOccurredWhileRetrievingTags'));
          return of(null);
        })
      ),
      status: this.documentsService.fetchDocumentsStatutes().pipe(
        catchError(() => {
          this.toastr.error(this.translater.translate('error.errorOccurredWhileFetchingDocumentsStatus'));
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.formatTags(value.tags);
      this.formatStatus(value.status);

      this.advancedSearch = true;
      if (sessionStorage.getItem('searchData')) {
        const data = JSON.parse(sessionStorage.getItem('searchData'));

        this.formSearch.patchValue({
          ClassementIds: data.ClassementIds,
          Confidentiel: data.Confidentiel,
          DestinataireIds: data.DestinataireIds,
          DestinataireServiceIds: data.DestinataireServiceIds,
          ExpediteurLibre: data.ExpediteurLibre,
          DestinataireLibre: data.DestinataireLibre,
          CourrierSansDestinataires: data.CourrierSansDestinataires,
          CourrierSansServices: data.CourrierSansServices,
          ReferenceRecommande: data.ReferenceRecommande,
          DtDocumentMax: data.DtDocumentMax ? moment(data.DtDocumentMax).toDate() : null,
          DtDocumentMin: data.DtDocumentMin ? moment(data.DtDocumentMin).toDate() : null,
          DtEcheanceMax: data.DtEcheanceMax ? moment(data.DtEcheanceMax).toDate() : null,
          DtEcheanceMin: data.DtEcheanceMin ? moment(data.DtEcheanceMin).toDate() : null,
          DtEntreeMax: data.DtEntreeMax ? moment(data.DtEntreeMax).toDate() : null,
          DtEntreeMin: data.DtEntreeMin ? moment(data.DtEntreeMin).toDate() : null,
          DtPostaleMax: data.DtPostaleMax ? moment(data.DtPostaleMax).toDate() : null,
          DtPostaleMin: data.DtPostaleMin ? moment(data.DtPostaleMin).toDate() : null,
          DtCreationMin: data.DtCreationMin ? moment(data.DtCreationMin).toDate() : null,
          DtCreationMax: data.DtCreationMax ? moment(data.DtCreationMax).toDate() : null,
          EtiquetteIds: data.EtiquetteIds,
          recurrence: data.recurrence,
          ExpediteurIds: data.ExpediteurIds,
          Key: data.Key,
          NatureIds: data.NatureIds,
          Objet: data.Objet,
          Text: data.Text,
          TextPhrase: data.TextPhrase,
          Remarques: data.Remarques,
          SourceIds: data.SourceIds,
          StIds: data.StIds,
          SvcPropIds: data.SvcPropIds,
          Type: data.Type,
          Tag: data.Tag,
          dateCourrier: data.dateCourrier ? moment(data.dateCourrier).toDate() : null,
          dateEntree: data.dateEntree ? moment(data.dateEntree).toDate() : null,
          typeOfAdvancedSearch: data.typeOfAdvancedSearch,
        });
        if (data.recurrence) {
          if (data.DtDocumentMin) {
            const diff = moment(data.DtDocumentMax).diff(moment(data.DtDocumentMin), 'days');

            this.formSearch.patchValue({
              DtDocumentMax: diff ? moment().add(diff, 'days').toDate() : null,
              DtDocumentMin: data.DtDocumentMin ? moment().toDate() : null,
            });
          }
          if (data.DtEcheanceMin) {
            const diff = moment(data.DtEcheanceMax).diff(moment(data.DtEcheanceMin), 'days');
            this.formSearch.patchValue({
              DtEcheanceMax: diff ? moment().add(diff, 'days').toDate() : null,
              DtEcheanceMin: data.DtEcheanceMin ? moment().toDate() : null,
            });
          }
          if (data.DtEntreeMin) {
            const diff = moment(data.DtEntreeMax).diff(moment(data.DtEntreeMin), 'days');
            this.formSearch.patchValue({
              DtEntreeMax: diff ? moment().add(diff, 'days').toDate() : null,
              DtEntreeMin: data.DtEntreeMin ? moment().toDate() : null,
            });
          }
          if (data.DtPostaleMin) {
            const diff = moment(data.DtPostaleMax).diff(moment(data.DtPostaleMin), 'days');
            this.formSearch.patchValue({
              DtPostaleMax: diff ? moment().add(diff, 'days').toDate() : null,
              DtPostaleMin: data.DtPostaleMin ? moment().toDate() : null,
            });
          }
          if (data.DtCreationMin) {
            const diff = moment(data.DtCreationMax).diff(moment(data.DtCreationMin), 'days');
            this.formSearch.patchValue({
              DtCreationMax: diff ? moment().add(diff, 'days').toDate() : null,
              DtCreationMin: data.DtCreationMin ? moment().toDate() : null,
            });
          }
        }
      } else {
        this.formSearch.value.typeOfAdvancedSearch = false;
      }
    });
  }

  private formatTags(tags: MultipleStatutesDTO[]): void {
    this.tags = [];
    if (tags?.length > 0) {
      tags.forEach((item) => {
        if (item.notUsed === false && item.description) {
          this.tags.push({ label: item.description, value: item.id });
        }
      });
    }
  }

  private formatStatus(status: DocumentStatusDto[]): void {
    this.statutGlobalLV = [];
    if (status.length > 0) {
      status.forEach((item) => {
        this.statutGlobalLV.push({
          label: item.description,
          value: item.id,
          color: item.color && item.color !== 'Pas de couleur' ? item.color : '#ffffff',
        });
      });
    }
  }

  searchFull(reset?): void {
    if (!reset) {
      sessionStorage.setItem('advancedSearch', 'oui');
      this.hasAdvancedSearch = true;
    }
    this.spinner.show();

    if (this.formSearch.value.DtDocumentMin) {
      this.formSearch.value.DtDocumentMin = moment(this.formSearch.value.DtDocumentMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtDocumentMax) {
      this.formSearch.value.DtDocumentMax = moment(this.formSearch.value.DtDocumentMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.datePostaleMin) {
      this.formSearch.value.datePostaleMin = moment(this.formSearch.value.datePostaleMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.datePostaleMax) {
      this.formSearch.value.datePostaleMax = moment(this.formSearch.value.datePostaleMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEntreeMin) {
      this.formSearch.value.DtEntreeMin = moment(this.formSearch.value.DtEntreeMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEntreeMax) {
      this.formSearch.value.DtEntreeMax = moment(this.formSearch.value.DtEntreeMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEcheanceMin) {
      this.formSearch.value.DtEcheanceMin = moment(this.formSearch.value.DtEcheanceMin).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.DtEcheanceMax) {
      this.formSearch.value.DtEcheanceMax = moment(this.formSearch.value.DtEcheanceMax).format('YYYY-MM-DD');
    }
    if (this.formSearch.value.BoolObjetText) {
      this.formSearch.value.Text = this.formSearch.value.Objet;
    }

    if (!this.currentTag || this.currentTag === '') {
      // Si on a pas de currentTag alors on va devoir toucher aux box et a l'url
      this.currentTag = 'all';
      this.selected = 'Tous les courriers';
      this.slugUrl = 'all';
    }
    let data = this.cleanObject(this.formSearch.value);

    if (this.currentTag !== 'aCreer') {
      data.Tag = this.currentTag ? this.currentTag : this.formSearch.value.Tag;
      if (this.currentTag === 'entrants' || this.currentTag === 'Entrant' || this.currentTag === 'E') {
        data.Type = 'E';
        delete data.Tag;
      }
      if (this.currentTag === 'sortants' || this.currentTag === 'Sortant' || this.currentTag === 'S') {
        data.Type = 'S';
        delete data.Tag;
      }
      if (this.currentTag === 'internes' || this.currentTag === 'Interne' || this.currentTag === 'I') {
        data.Type = 'I';
        delete data.Tag;
      }
      if (localStorage.getItem('bacsIds')) {
        delete data.Tag;
        data.BacIds = localStorage.getItem('bacsIds');
      }
      sessionStorage.setItem('searchData', JSON.stringify(data));
      this.searchString = '';
      if (data.Id) {
        this.mailsService.fetchMailsById(data.Id).subscribe({
          next: (res: MailDTO) => {
            if (res) {
              let mailResponse = new Mail(res);
              this.searchLoaded = true;
              this.pageNumber = 1;
              this.numberCourrier = 1;
              if (mailResponse.statutId && this.globalStatus.length > 0) {
                mailResponse = this.setMailStatus(mailResponse);
              }
              if (mailResponse.sourceId && this.sourceListLV.length > 0) {
                mailResponse = this.setMailSource(mailResponse);
              }
              this.setExpediteur(mailResponse).then((mail) => {
                mailResponse = new Mail(mail);
                this.getColumns();
                this.manageMail(res);
              });
            } else {
              this.spinner.hide();
              this.isLoading = false;
              this.mails = [];
            }
          },
          error: (err) => {
            console.error(err);
            this.spinner.hide();
            this.isLoading = false;
            this.mails = [];
          },
        });
      } else {
        delete data.typeOfAdvancedSearch;
        if (this.currentTag === 'Sortant') {
          data.Type === 'S';
          delete data.Tag;
        }
        if (this.currentTag === 'Entrant') {
          data.Type === 'E';
          delete data.Tag;
        }
        if (this.currentTag === 'Interne') {
          data.Type === 'I';
          delete data.Tag;
        }

        if (data.Objet) data.Objet = encodeURIComponent(data.Objet);
        data = {
          ...data,
          CalcTotal: false,
        };

        sessionStorage.setItem('searchData', JSON.stringify(data));
        this.getAllMailsCount(data);

        this.mailsService.getAllMails(data, this.sizeChoice).subscribe({
          next: (res) => {
            this.mails = [];
            this.mailsObject = res;
            this.searchLoaded = true;
            this.pageNumber = 1;

            if (res?.items?.length > 0) {
              // On va commencer par récupérer les expéditeurs de iCourrier
              const sendersiCourrierFromResponse = _.uniq(
                res.items.filter((expediteur) => !!expediteur.expediteurId).map((expediteur) => expediteur.expediteurId)
              );
              const sendersiCourrierFromQuery = data.ExpediteurIds || [];
              const recipientiCourrierFromQuery = data.DestinataireIds || [];
              const listOfExpediteuriCourrierIds = _.uniq([
                ...sendersiCourrierFromResponse,
                ...sendersiCourrierFromQuery,
                ...recipientiCourrierFromQuery,
              ]);

              // Puis on va faire de même avec les expéditeurs de iAdmin
              const sendersiAdminFromResponse = _.uniq(
                res.items.filter((expediteur) => !!expediteur.expediteurIdiAdmin).map((expediteur) => expediteur.expediteurIdiAdmin)
              );
              const sendersiAdminFromQuery = data.ExpediteurIdiAdmins || [];
              const recipientiAdminFromQuery = data.DestinataireIdiAdmins || [];
              const listOfExpediteuriAdminIds = _.uniq([...sendersiAdminFromResponse, ...sendersiAdminFromQuery, ...recipientiAdminFromQuery]);

              forkJoin({
                lowInfoIC: listOfExpediteuriCourrierIds.length
                  ? this.getLowInformationsContactIds(listOfExpediteuriCourrierIds, 'getLowInformationsContactsiCourrier')
                  : of([]),
                lowInfosIAdmin: listOfExpediteuriAdminIds.length
                  ? this.getLowInformationsContactIds(listOfExpediteuriAdminIds, 'getLowInformationsContactsiAdmin')
                  : of([]),
              }).subscribe((value) => {
                this.contacts = value.lowInfoIC.map((expediteur) => new Contact(expediteur));
                this.contactsiAdmin = value.lowInfosIAdmin.map((expediteur) => new Contact(expediteur));

                res.items.forEach((mail) => {
                  let mailFullInfo = new Mail(mail);

                  if (mailFullInfo.statutId && this.globalStatus.length > 0) {
                    mailFullInfo = this.setMailStatus(mailFullInfo);
                  }
                  if (mailFullInfo.sourceId && this.sourceListLV.length > 0) {
                    mailFullInfo = this.setMailSource(mailFullInfo);
                  }
                  if (mailFullInfo.expediteurId) {
                    const foundSender = this.contacts.find((contact) => contact.id === mailFullInfo.expediteurId);
                    if (foundSender) {
                      mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                    }
                  } else if (mailFullInfo.expediteurIdiAdmin) {
                    const foundSender = this.contactsiAdmin.find((contact) => contact.id === mailFullInfo.expediteurIdiAdmin);
                    if (foundSender) {
                      mailFullInfo.expTitle = (foundSender.prenom ? foundSender.prenom + ' ' : '') + '' + (foundSender.nom ? foundSender.nom : '');
                    }
                  }
                  this.mails.push(mailFullInfo);
                  this.spinner.hide();
                });
                this.getColumns();
                if (this.mailActive) {
                  const tempMailActive = this.mails.find((m) => m.id === this.mailActive.id);
                  if (tempMailActive) {
                    this.getMailActive(this.mailActive.id);
                  } else {
                    this.getMailActive(this.mails[0].id);
                  }
                } else {
                  const IDurl = location.pathname.split('/').slice(-1)[0];
                  this.idMailActive = +IDurl;
                  if (this.idMailActive === null || (Number.isNaN(this.idMailActive) && this.mails.length > 0)) {
                    this.getMailActive(this.mails[0].id);
                  } else {
                    const tempMailActive = this.mails.find((m) => m.id === this.idMailActive);
                    if (tempMailActive) {
                      this.getMailActive(this.idMailActive);
                    } else {
                      this.getMailActive(this.mails[0].id);
                    }
                  }
                }
                if (sessionStorage.getItem('searchData')) {
                  sessionStorage.setItem('reloadData', 'oui');
                }
                this.spinner.hide();
              });
            } else {
              this.spinner.hide();
              this.welcomeMode = true;
              if (sessionStorage.getItem('searchData')) {
                sessionStorage.setItem('reloadData', 'oui');
              }
              this.spinner.hide();
            }
          },
          error: (err) => {
            console.error(err);
            this.spinner.hide();
            this.isLoading = false;
            this.toastr.error(this.translater.translate('errorOccurredWhenRecoveringDatas'));
            this.mails = [];
          },
        });
      }
    } else {
      if (sessionStorage.getItem('searchData')) {
        sessionStorage.setItem('reloadData', 'oui');
      }
      this.spinner.hide();
    }
  }

  cleanObject(object) {
    const propNames = Object.getOwnPropertyNames(object);
    for (let i = 0; i < propNames.length; i++) {
      const propName = propNames[i];
      if (object[propName] === null || object[propName] === undefined || object[propName] === '') {
        delete object[propName];
      }
    }
    return object;
  }

  selectMultiple(event): void {
    this.multipleItemsSelected = event;
  }

  validate(multipleItemsSelected): void {
    if (multipleItemsSelected.length > 0) {
      this.confirmService.confirm({
        message: this.translater.translate('homeCourrierChild.homeCourrierChild'),
        accept: () => {
          const data = {
            mailIds: [],
          };
          multipleItemsSelected.map((item) => {
            data.mailIds.push(item.id);
          });
          if (data.mailIds.length > 0) {
            this.mailsService.validateMail(data).subscribe({
              next: () => {
                this.toastr.success(this.translater.translate('homeCourrierChild.modificationSavedSuccessfully'));
                const data = {
                  ...JSON.parse(sessionStorage.getItem('searchData')),
                  CalcTotal: false,
                };
                this.searchWithData(data, true, false);
              },
              error: (error) => {
                console.error(error);
                this.toastr.error(this.translater.translate('homeCourrierChild.noPermissionToValidateMail'));
              },
            });
          }
        },
      });
    }
  }
  distribute(multipleItemsSelected): void {
    if (multipleItemsSelected.length > 0) {
      this.confirmService.confirm({
        message: this.translater.translate('homeCourrierChild.doYouWantToMarkDistributed'),
        accept: () => {
          const data = {
            mailIds: [],
          };
          multipleItemsSelected.map((item) => {
            data.mailIds.push(item.id);
          });
          if (data.mailIds.length > 0) {
            this.mailsService.markAsDistributed(data).subscribe({
              next: () => {
                this.toastr.success(this.translater.translate('homeCourrierChild.modificationSavedSuccessfully'));
                const data = {
                  ...JSON.parse(sessionStorage.getItem('searchData')),
                  CalcTotal: false,
                };
                this.searchWithData(data, true, false);
              },
              error: (error) => {
                console.error(error);
                this.toastr.error(this.translater.translate('homeCourrierChild.noPermissionToValidateMail'));
              },
            });
          }
        },
      });
    }
  }

  openSavedSearch(): void {
    this.openSavedSearchs = true;
    this.meService.getMyPersonalParams('CourrierRechercheSauvegardee').subscribe({
      next: (res: PersonalParams[]) => {
        this.itemsSaved = [];
        if (res && res.length > 0) {
          this.itemsSaved = res;
        }
      },
    });
  }

  patchFormSearch(value): void {
    const data = JSON.parse(value.value);

    this.formSearch.patchValue({
      ClassementIds: data.ClassementIds,
      Confidentiel: data.Confidentiel,
      DestinataireIds: data.DestinataireIds,
      DestinataireServiceIds: data.DestinataireServiceIds,
      ReferenceRecommande: data.ReferenceRecommande,
      DtDocumentMax: data.DtDocumentMax ? moment(data.DtDocumentMax).toDate() : null,
      DtDocumentMin: data.DtDocumentMin ? moment(data.DtDocumentMin).toDate() : null,
      DtEcheanceMax: data.DtEcheanceMax ? moment(data.DtEcheanceMax).toDate() : null,
      DtEcheanceMin: data.DtEcheanceMin ? moment(data.DtEcheanceMin).toDate() : null,
      DtEntreeMax: data.DtEntreeMax ? moment(data.DtEntreeMax).toDate() : null,
      DtEntreeMin: data.DtEntreeMin ? moment(data.DtEntreeMin).toDate() : null,
      DtPostaleMax: data.DtPostaleMax ? moment(data.DtPostaleMax).toDate() : null,
      DtPostaleMin: data.DtPostaleMin ? moment(data.DtPostaleMin).toDate() : null,
      DtCreationMin: data.DtCreationMin ? moment(data.DtCreationMin).toDate() : null,
      DtCreationMax: data.DtCreationMax ? moment(data.DtCreationMax).toDate() : null,
      EtiquetteIds: data.EtiquetteIds,
      recurrence: data.recurrence,
      ExpediteurIds: data.ExpediteurIds,
      Key: data.Key,
      NatureIds: data.NatureIds,
      Objet: data.Objet,
      Text: data.Text,
      TextPhrase: data.TextPhrase,
      Remarques: data.Remarques,
      SourceIds: data.SourceIds,
      StIds: data.StIds,
      SvcPropIds: data.SvcPropIds,
      Type: data.Type,
      dateCourrier: data.dateCourrier ? moment(data.dateCourrier).toDate() : null,
      dateEntree: data.dateEntree ? moment(data.dateEntree).toDate() : null,
      ExpediteurLibre: data.ExpediteurLibre,
      DestinataireLibre: data.DestinataireLibre,
      CourrierSansDestinataires: data.CourrierSansDestinataires,
      CourrierSansServices: data.CourrierSansServices,
      typeOfAdvancedSearch: data.typeOfAdvancedSearch,
    });

    if (data.recurrence) {
      if (data.DtDocumentMin) {
        const diff = moment(data.DtDocumentMax).diff(moment(data.DtDocumentMin), 'days');

        this.formSearch.patchValue({
          DtDocumentMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtDocumentMin: data.DtDocumentMin ? moment().toDate() : null,
        });
      }
      if (data.DtEcheanceMin) {
        const diff = moment(data.DtEcheanceMax).diff(moment(data.DtEcheanceMin), 'days');
        this.formSearch.patchValue({
          DtEcheanceMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtEcheanceMin: data.DtEcheanceMin ? moment().toDate() : null,
        });
      }
      if (data.DtEntreeMin) {
        const diff = moment(data.DtEntreeMax).diff(moment(data.DtEntreeMin), 'days');
        this.formSearch.patchValue({
          DtEntreeMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtEntreeMin: data.DtEntreeMin ? moment().toDate() : null,
        });
      }
      if (data.DtPostaleMin) {
        const diff = moment(data.DtPostaleMax).diff(moment(data.DtPostaleMin), 'days');
        this.formSearch.patchValue({
          DtPostaleMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtPostaleMin: data.DtPostaleMin ? moment().toDate() : null,
        });
      }
      if (data.DtCreationMin) {
        const diff = moment(data.DtCreationMax).diff(moment(data.DtCreationMin), 'days');
        this.formSearch.patchValue({
          DtCreationMax: diff ? moment().add(diff, 'days').toDate() : null,
          DtCreationMin: data.DtCreationMin ? moment().toDate() : null,
        });
      }
    }
    this.openSavedSearchs = false;
  }

  deleteSearch(value): void {
    this.meService.deletePersonalParams(value.id, 'CourrierRechercheSauvegardee').subscribe({
      next: () => {
        this.openSavedSearchs = false;
        this.toastr.success(this.translater.translate('homeCourrierChild.searchDeleted'));
        sessionStorage.setItem('reloadDashboard', '1');
      },
    });
  }

  showDialog(value): void {
    const url = '/private/ic/tabs/';
    const config = environment;
    window.open(config.baseUrl + url + value.id);
  }

  openCreateModal(value): void {
    sessionStorage.setItem('courrierIDAnswer', value.id.toString());
    let mailType = 'E';
    //le 23/02/2024, Gwen a donné ces informations métiers :
    // répondre a une fiche courrier qui est de base 'entrant' => créer un sortant (si on en a le droit)
    if (value.typeEntrantSortant == 'Entrant') {
      mailType = this.userInfos.encodageNouveauSortant ? 'S' : 'E';
    }
    // répondre a une fiche courrier qui est de base 'sortant' => créer un entrant (si on en a le droit)
    if (value.typeEntrantSortant == 'Sortant') {
      mailType = this.userInfos.encodageNouveauEntrant ? 'E' : 'S';
    }
    // répondre a une fiche courrier qui est de base 'interne' => créer un interne
    if (value.typeEntrantSortant == 'Interne') {
      mailType = 'I';
    }
    const data: MailInfosViaExtraStateRouter = {
      isAnswerMode: true,
      origin: 'courrierFicheForm',
      mailId: value.id,
      mail: value,
      expediteurId: value.expediteurId,
      mailType: mailType,
      isNew: true,
    };
    this.router.navigate(['/private/ic/new'], { state: data });
  }

  update(courrier) {
    this.mailsLockUnlockService.getLockInfo(courrier.id).subscribe({
      next: (res) => {
        const lastLocks: MailLockEntryDTO[] = res;
        let hasAlreadySomeOneWhoWrite = null;
        hasAlreadySomeOneWhoWrite = _.last(res);
        if (res.length > 0 && hasAlreadySomeOneWhoWrite.lockMode === 'Write' && this.userInfos.contactId !== hasAlreadySomeOneWhoWrite.contactId) {
          this.toastr.warning("Quelqu'un modifie actuellement ce courrier");
        } else {
          let lastLockVersion = 0;
          if (lastLocks.length > 0) {
            lastLockVersion = _.last(lastLocks).version;
          } else if (courrier.version) {
            lastLockVersion = courrier.version;
          } else {
            lastLockVersion = 1;
          }
          this.lock(courrier.id, lastLockVersion, 'Write').then(() => {
            this.router.navigate(['/private/ic/new/' + courrier.id, { mode: 'edit' }]);
          });
        }
      },
    });
  }

  openAssistant(courrier): void {
    this.dialogService.open(CModeChoiceModalComponent, {
      dismissableMask: false,
      width: '60vw',
      header: 'Type de mail',
      baseZIndex: 1000,
      data: {
        newMail: courrier,
        modeAnswer: false,
        showOnlyEmailOption: true,
      },
    });
  }

  createAction(courrier): void {
    const ref = this.dialogService.open(ActionCreateModalComponent, {
      dismissableMask: false,
      header: 'Créer une action',
      width: '70vw',
      closable: false,
      baseZIndex: 1000,
      data: {
        currentCourrier: courrier,
      },
    });

    ref.onClose.subscribe({
      next: (value) => {
        value ? this.ngOnInit() : '';
      },
    });
  }
  transfer(courrier): void {
    const ref = this.dialogService.open(RecipientModalComponent, {
      closable: false,
      showHeader: false,
      dismissableMask: false,
      header: 'Destinataires',
      width: '60vw',
      baseZIndex: 1000,
      data: {
        courrierID: courrier.id,
      },
    });
    ref.onClose.subscribe({
      next: (data: RecipientModalOnCloseDatas) => {
        if (data) {
          const arrayIDToCheck = [];

          if (data.contactArray.length > 0) {
            data.contactArray.forEach((item) => {
              arrayIDToCheck.push(item.value);
            });
          }

          if (arrayIDToCheck?.length) {
            this.fetchReplacingPeople(arrayIDToCheck, data, courrier.id);
          } else {
            this.setDatasAndCallAddDestinataires(data, [], courrier.id);
          }
        }
      },
    });
  }

  private setDatasAndCallAddDestinataires(data: RecipientModalOnCloseDatas, remplacantArray, courrierId: number): void {
    if (remplacantArray.length) {
      data.contactArray = remplacantArray;
    }
    this.addDestinataires(data, courrierId);
  }

  private fetchReplacingPeople(arrayIDToCheck, data: RecipientModalOnCloseDatas, courrierId: number): void {
    this.contactsService.fetchContactsRemplacantsiCourrier(arrayIDToCheck).subscribe({
      next: (res) => {
        const hasAbsentPeopleArray: ContactsRemplacantDTO[] = [];
        if (res?.length) {
          res.forEach((remplacant) => {
            data.contactArray.forEach((dest) => {
              if (remplacant.absent === true && dest.value === remplacant.contactId) {
                hasAbsentPeopleArray.push(remplacant);
              }
            });
          });
        }
        if (hasAbsentPeopleArray.length > 0) {
          this.confirmReplaceContactsInHolidays(res, data, courrierId);
        } else {
          this.setDatasAndCallAddDestinataires(data, [], courrierId);
        }
      },
    });
  }

  private confirmReplaceContactsInHolidays(res: ContactsRemplacantDTO[], data: RecipientModalOnCloseDatas, courrierId: number): void {
    const remplacantArray = [];
    this.confirmService.confirm({
      message: 'Souhaitez-vous remplacer automatiquement les personnes qui sont en congés ?',
      key: 'remplacant',
      accept: () => {
        async.eachSeries(
          res,
          (item, next) => {
            if (item.absent) {
              const contactArrayLinked = data.contactArray.filter((dest) => dest.value === item.contactId);
              if (contactArrayLinked?.length) {
                this.contactsService.fetchContact(item.remplaceParContactId, 'iAdmin').subscribe({
                  next: (res: ContactDto) => {
                    if (res) {
                      remplacantArray.push(
                        contactArrayLinked[0],
                        new Contact({
                          value: item.remplaceParContactId,
                          name: (res.prenom ? res.prenom : '') + ' ' + (res.nom ? res.nom : ''),
                          label: (res.prenom ? res.prenom : '') + ' ' + (res.nom ? res.nom : ''),
                          type: 'DESTINATAIRE',
                          lastname: res.prenom ? res.prenom : '',
                          nom: res.nom ? res.nom : '',
                          prenom: res.prenom ? res.prenom : '',
                        })
                      );
                      next();
                    } else next();
                  },
                });
              } else next();
            } else next();
          },
          () => {
            this.setDatasAndCallAddDestinataires(data, remplacantArray, courrierId);
          }
        );
      },
      reject: () => {
        this.setDatasAndCallAddDestinataires(data, [], courrierId);
      },
    });
  }

  /**
   * Method to add one or multiple recipients to the current courrier
   * @param newDestArray array of destinataire
   */
  public addDestinataires(data, courrierId: number): void {
    if (data) {
      this.spinner.show();
      this.addFreeRecipients(data.freeRecipientArray, courrierId).then(() => {
        const listOfDatas = {
          libre: null,
          contacts: [
            ...data.contactArray.map((item) => ({
              contactId: item.value,
              historiqueDescription: item.label,
            })),
            ...data.usersArray.map((item) => ({
              contactIdiAdmin: item.value,
              historiqueDescription: item.label,
            })),
          ],
          serviceIds: data.serviceArray.map((item) => item.value),
          groupeIds: data.groupsArray.map((item) => item.id),
        };
        this.recipientsService.addMailsDestinataires(courrierId, listOfDatas).subscribe({
          next: () => {
            this.toastr.success('Destinataire(s) ajouté(s)!');
            this.spinner.hide();
          },
        });
      });
    }
  }

  private addFreeRecipients(
    freeRecipientArray: {
      id: string;
      name: string;
    }[],
    courrierId: number
  ): Promise<boolean> {
    return new Promise((resolve) => {
      if (!freeRecipientArray?.length) return resolve(true);
      async.eachSeries(
        freeRecipientArray,
        (item, next) => {
          const destinataireInput = {
            libre: item.name,
            contacts: [],
          };
          this.recipientsService.addMailsDestinataires(courrierId, destinataireInput).subscribe({
            next: () => {
              next();
            },
            error: (error) => {
              console.error('Error : ', error);
              this.toastr.error("Erreur lors de l'ajout de : " + destinataireInput.libre);
              next();
            },
          });
        },
        () => {
          resolve(true);
        }
      );
    });
  }

  duplicate(courrier): void {
    this.dialogService.open(DuplicateModalsComponent, {
      dismissableMask: true,
      showHeader: false,
      styleClass: 'super-compos-modal-content',
      width: '50vw',
      baseZIndex: 1000,
      data: {
        courrier: courrier,
      },
    });
  }

  pin(courrier, activate: boolean): void {
    let rightMail: MeRightMail = null;
    this.mailsRightsService.getRightsMailByID(courrier.id).subscribe({
      next: (res) => {
        rightMail = res;
        if (rightMail.pin) {
          this.mailsService.pinMail(courrier.id, activate).subscribe({
            next: () => {
              activate === true ? this.toastr.success('Courrier épinglé !') : this.toastr.success('Courrier désépinglé !');
              this.dataService.setRefreshList(true);
              this.ngOnInit();
            },
          });
        } else {
          this.toastr.warning(this.translater.translate('homeCourrierChild.noPermissionToPinUnpinMail'));
        }
      },
    });
  }

  saveColumn(event): void {
    const data: PersonalParamsParams = {
      name: this.idTable,
      description: 'Les colonnes de ' + this.idTable,
      value: event,
      shared: true,
      displayOrder: 0,
      hideInDashboard: true,
    };
    if (this.currentView) {
      this.meService.putMyPersonalParams(this.currentView.id, 'CourrierCustomViews', data).subscribe({
        next: () => {
          this.toastr.success(this.translater.translate('homeCourrierChild.choicesSaved'));
        },
      });
    } else {
      this.meService.postMyPersonalParams('CourrierCustomViews', data).subscribe({
        next: () => {
          this.toastr.success(this.translater.translate('homeCourrierChild.choicesSaved'));
        },
      });
    }
  }

  deleteCourrier(items): void {
    let count = 0;
    if (items?.length > 0) {
      items.map((item) => {
        this.mailsService.deleteCourrier(item.id, true).subscribe({
          next: () => {
            this.toastr.success(this.translater.translate('homeCourrierChild.courrierDeleted'));
            count = count + 1;
            if (count === items.length) {
              this.ngOnInit();
            }
          },
          error: () => {
            this.toastr.warning(this.translater.translate('homeCourrierChild.youCanDeleteCourrier', { item: item.id }));
            count = count + 1;
          },
        });
      });
    }
  }

  scrollMethods(): void {
    let data: MailsMeSearchParams = {};
    const dataSession = JSON.parse(sessionStorage.getItem('searchData'));

    switch (this.title) {
      case 'Tous les courriers':
        data.Tag = 'All';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Tous les entrants':
        data.Type = 'E';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Tous les sortants':
        data.Type = 'S';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Tous les internes':
        data.Type = 'I';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Non lu(s)':
        data.Tag = 'NonLus';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Lu(s)':
        data.Tag = 'Lus';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Demandes non prises en charge par mon service':
        data.Tag = 'NonPrisEnCharge';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Prise en charge pour mon service':
        data.Tag = 'APrendreEnCharge';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Epinglé(s)':
        data.Tag = 'Epingles';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Prise en charge demandée par mon service':
        data.Tag = 'PrisEnCharge';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Pour action':
        data.Tag = 'PourAction';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Pour information':
        data.Tag = 'PourInfo';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Mal routé(s)':
        data.Tag = 'MalRoutes';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        this.showMore(data);
        break;
      case 'Courriers entrants à valider':
        data = {
          Tag: 'AValider',
          Type: 'E',
        };
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'A distribuer':
        data.Tag = 'ADistribuer';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'A valider':
        data = {
          Tag: 'AValider',
          Type: 'E',
          PageNumber: this.pageNumber >= 1 ? +this.pageNumber + 1 : 0,
        };
        sessionStorage.setItem('Tag', 'AValider');
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'A compléter':
        data.Tag = 'ACompleter';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Sortant à valider':
        data.Tag = 'AValider';
        data.Type = 'Sortant';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Récemment consulté(s)':
        data.DtConsultMin = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Récemment créé(s)':
        data.DtEntreeMin = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      case 'Courrier à classer':
        data.Tag = 'AClasser';
        data.PageNumber = this.pageNumber >= 1 ? +this.pageNumber + 1 : 0;
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
      default:
        data = {
          PageNumber: this.pageNumber >= 1 ? +this.pageNumber + 1 : 0,
        };
        if (dataSession !== null) {
          Object.assign(data, dataSession);
        }
        this.spinner.show();
        this.showMore(data);
        break;
    }
  }

  onChangeNewVisual(): void {
    //on va ré-effectuer la recherche actuelle de l'utilisateur s'il a changé de page ou de nombre de courriers affichés
    //comme cela en changeant de vue, il aura toujours sa recherche mais en page 1 avec de base50 courriers affichés
    this.selectedTabs = this.selectedTabArrayNewVisual.slug;
    if (this.pageNumber != 1 || this.sizeChoice !== 50) {
      const data = {
        ...JSON.parse(sessionStorage.getItem('searchData')),
        CalcTotal: false,
      };
      data.PageNumber = 1;
      this.sizeChoice = 50;
      this.searchWithData(data, false, true);
    }
    this.getColumns();
  }

  onClickDropdownInput(type): void {
    this.dropdownLabel = this.translater.translate(type);
    this.dropdownValue = type;
    this.showOverlayDropdown = false;
    if (type !== 'Services' && this.searchString && this.searchString !== '') {
      //si on a pas cliqué sur 'Service" on doit vérifier qu'il y a une searchString
      this.searchMail();
    } else if (type === 'Services') {
      // Ici on doit juste vérifier qu'on a cliqué sur 'Services'
      this.openModalTreeServicesSelection = true;
    }
  }

  sendServicesToSearch(): void {
    if (this.selectedOption.length > 0) {
      const arrayOfIds = this.selectedOption.map((x) => x.value);
      this.inputDisplayOnServiceSearch = this.selectedOption[0].description ? this.selectedOption[0].description : this.selectedOption[0].label;
      if (this.selectedOption.length > 1) {
        this.inputDisplayOnServiceSearch = this.inputDisplayOnServiceSearch + ' ( + ' + (this.selectedOption.length - 1) + ' autres )';
      }
      this.inputDisplayOnServiceSearchTooltip = this.selectedOption
        .map((x) => {
          return x.label;
        })
        .join(', ');
      this.activeModeSearch = 'serviceSearch';
      this.openModalTreeServicesSelection = false;
      this.searchMail(arrayOfIds);
    } else {
      this.toastr.info(this.translater.translate('homeCourrierChild.chooseServices'));
    }
  }

  receive_menu(event): void {
    this.selectedCourrierForMenu = event;
    this.itemsMenu = [{}];
    this.mailsRightsService.getRightsMailByID(event.id).subscribe({
      next: (res: MeRightMail) => {
        if (res.edit) {
          this.itemsMenu.push({
            label: this.translater.translate('homeCourrierChild.modify'),
            icon: 'icon-create',
            command: (item) => {
              this.update(item);
            },
          });
          this.itemsMenu = [...this.itemsMenu];
        }
        if (res) {
          this.itemsMenu.push({
            label: this.translater.translate('homeCourrierChild.requestAction'),
            icon: 'icon-rocket',
            command: (item) => {
              this.createAction(item);
            },
          });
          this.itemsMenu = [...this.itemsMenu];
        }
        this.itemsMenu.push({
          label: this.translater.translate('homeCourrierChild.sendForInformation'),
          icon: 'icon-transfer',
          command: (item) => {
            this.transfer(item);
          },
        });
        if (this.configuration.isSmtpConfigured) {
          this.itemsMenu.push({
            label: this.translater.translate('homeCourrierChild.mailAssistant'),
            icon: 'bi bi-envelope-paper',
            command: (item) => {
              this.openAssistant(item);
            },
          });
          this.itemsMenu = [...this.itemsMenu];
        }
        if (res.pin) {
          this.itemsMenu.push({
            label:
              event.pinned && event.pinned === true
                ? this.translater.translate('homeCourrierChild.unpin')
                : this.translater.translate('homeCourrierChild.pin'),
            icon: 'icon-pin1',
            command: (item) => {
              if (event.pinned && event.pinned === true) {
                this.pin(item, false);
              } else {
                this.pin(item, true);
              }
            },
          });
          this.itemsMenu = [...this.itemsMenu];
        }
        if (res) {
          this.itemsMenu.push({
            label: this.translater.translate('homeCourrierChild.duplicate'),
            icon: 'bi bi-copy',
            command: (item) => {
              this.duplicate(item);
            },
          });
          this.itemsMenu = [...this.itemsMenu];
        }
        this.itemsMenu.splice(0, 1);
      },
    });
  }

  getColumns(): void {
    this.columnTable = [
      {
        field: 'id',
        header: this.translater.translate('id'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },
        export: (value) => {
          return value;
        },
      },
      {
        field: 'objet',
        header: this.translater.translate('object'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'expGroup',
        header: this.translater.translate('service'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'typeEntrantSortant',
        header: this.translater.translate('advancedSearch.type'),
        format: (value): string => {
          if (value === 'S') {
            return 'Sortant';
          } else if (value === 'E') {
            return 'Entrant';
          } else {
            return 'Interne';
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'boiteArchive',
        header: this.translater.translate('admin.archiveBox'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },
        export: (value) => {
          return value;
        },
      },
      {
        field: 'nature',
        header: this.translater.translate('nature'),
        format: (value): string => {
          if (value?.description) {
            return value.description;
          }
        },
        export: (value) => {
          return value;
        },
      },
      {
        field: 'source',
        header: this.translater.translate('source'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'expTitle',
        header: this.translater.translate('sender'),
        format: (value, item): string => {
          if (value) {
            //si on a un expediteurId, on a expTitle
            return value;
          } else {
            //Si pas on va check si on a un expéditeur libre
            if (item.expediteurLibre) {
              return item.expediteurLibre + ' (Libre)';
            }
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'refExpediteur',
        header: this.translater.translate('senderRef'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'referenceRecommande',
        header: this.translater.translate('referenceRecommande'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'classementCode',
        header: this.translater.translate('courrierFiche.filling'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'classeurDescription',
        header: this.translater.translate('courrierFiche.filingCabinet'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'chemiseDescription',
        header: this.translater.translate('courrierFiche.folder'),
        format: (value): string => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'statusObjet',
        header: this.translater.translate('status.title'),
        format: (value): string => {
          if (value?.name) {
            return value.name;
          }
        },

        export: (value) => {
          return value;
        },
      },
      {
        field: 'dateEntree',
        header: this.translater.translate('entryDate'),
        format: (value): string => {
          if (value) {
            return moment(value).format('DD/MM/YYYY');
          }
        },
        export: (value) => {
          return value;
        },

        sort: (a, b, order) => {
          const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
          const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
          if (val1 === null) return 1;
          else if (val2 === null) return -1;
          else return val1 < val2 ? 1 * order : -1 * order;
        },
        sortable: true,
      },
      {
        field: 'dateEcheance',
        header: this.translater.translate('action.colHead.echeance'),
        format: (value): string => {
          if (value) {
            return moment(value).format('DD/MM/YYYY');
          }
        },

        export: (value) => {
          return value;
        },
        sort: (a, b, order) => {
          const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
          const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
          if (val1 === null) return 1;
          else if (val2 === null) return -1;
          else return val1 < val2 ? 1 * order : -1 * order;
        },
        sortable: true,
      },
      {
        field: 'dateDocument',
        header: this.translater.translate('admin.documentDate'),
        format: (value): string => {
          if (value) {
            return moment(value).format('DD/MM/YYYY');
          }
        },
        export: (value) => {
          return value;
        },

        sort: (a, b, order) => {
          const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
          const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
          if (val1 === null) return 1;
          else if (val2 === null) return -1;
          else return val1 < val2 ? 1 * order : -1 * order;
        },
        sortable: true,
      },
      {
        field: 'datePostale',
        header: this.translater.translate('postalDate'),
        format: (value): string => {
          if (value) {
            return moment(value).format('DD/MM/YYYY');
          }
        },
        export: (value) => {
          return value;
        },

        sort: (a, b, order) => {
          const val1 = moment(a, 'DD/MM/YYYY').isValid() ? moment(a, 'DD/MM/YYYY').unix() : null;
          const val2 = moment(b, 'DD/MM/YYYY').isValid() ? moment(b, 'DD/MM/YYYY').unix() : null;
          if (val1 === null) return 1;
          else if (val2 === null) return -1;
          else return val1 < val2 ? 1 * order : -1 * order;
        },
        sortable: true,
      },
      {
        field: 'avalider',
        header: this.translater.translate('advancedSearch.toValidate'),
        format: (value): string => {
          if (value === true) {
            return `✅`;
          } else {
            return `❌`;
          }
        },
        export: (value) => {
          return value;
        },
      },
      {
        field: 'confidentiel',
        header: this.translater.translate('homeCourrierChild.advancedSearch.confidential'),
        format: (value): string => {
          if (value === true) {
            return `✅`;
          } else {
            return `❌`;
          }
        },
        export: (value) => {
          return value;
        },
      },
      {
        field: 'remarques',
        header: this.translater.translate('remarks'),
        format: (value) => {
          if (value) {
            return value;
          }
        },

        export: (value) => {
          return value;
        },
      },
    ];
  }

  private setExpediteur(mail: Mail): Promise<Mail> {
    return new Promise((resolve) => {
      if (mail.expediteurId) {
        this.getLowInformationsSenderForAMail(mail, 'getLowInformationsContactsiCourrier').then((mail) => {
          resolve(mail);
        });
      } else if (mail.expediteurIdiAdmin) {
        this.getLowInformationsSenderForAMail(mail, 'getLowInformationsContactsiAdmin').then((mail) => {
          resolve(mail);
        });
      } else {
        this.contacts = [];
        this.contactsiAdmin = [];
        mail.expTitle = '';
        resolve(mail);
      }
    });
  }

  /**
   * Set the expediteur for a mail object from the id stored in the mail
   * @param mail the mail object to set the expediteur
   * @param methodName the name of the method to call on the contactsService: 'getLowInformationsContactsiCourrier' or 'getLowInformationsContactsiAdmin'
   * @returns a promise that resolves with the mail object with the expediteur set
   */
  private getLowInformationsSenderForAMail(
    mail: Mail,
    methodName: 'getLowInformationsContactsiCourrier' | 'getLowInformationsContactsiAdmin'
  ): Promise<Mail> {
    return new Promise((resolve) => {
      const senderToSend = mail.expediteurId ? mail.expediteurId : mail.expediteurIdiAdmin;
      this.contactsService[methodName]({ id: [senderToSend] }).subscribe({
        next: (expediteurFound: LowInformationsDTO[]) => {
          if (mail.expediteurId) {
            this.contacts = expediteurFound.map((expediteur) => new Contact(expediteur));
          } else if (mail.expediteurIdiAdmin) {
            this.contactsiAdmin = expediteurFound.map((expediteur) => new Contact(expediteur));
          }
          mail.expTitle =
            (expediteurFound[0].prenom ? expediteurFound[0].prenom + ' ' : '') + '' + (expediteurFound[0].nom ? expediteurFound[0].nom : '');
          return resolve(mail);
        },
      });
    });
  }

  /**
   * Retrieves contact information for a list of sender IDs.
   *
   * This method calls a specified `contactsService` method to fetch
   * contact information for the provided list of sender IDs. It returns
   * a promise that resolves with the fetched contact data.
   *
   * @param listOfSenderIds - An array of sender IDs for which contact information is required.
   * @param methodName - The name of the method in `contactsService` used to fetch contact information.
   * @returns A promise that resolves with the contact information retrieved by the specified method.
   */

  private getLowInformationsContactIds(
    listOfSenderIds: number[],
    methodName: 'getLowInformationsContactsiCourrier' | 'getLowInformationsContactsiAdmin'
  ): Promise<LowInformationsDTO[]> {
    return new Promise((resolve) => {
      this.contactsService[methodName]({ id: listOfSenderIds }).subscribe({
        next: (res) => {
          resolve(res);
        },
      });
    });
  }

  private setMailStatus(mail: Mail): Mail {
    this.globalStatus.forEach((status) => {
      if (mail.statutId === status.id) {
        mail.statusObjet = {
          name: status.description,
          background: status.color && status.color !== 'Pas de couleur' ? status.color : '#ffffff',
          color: this.getOppositeColor(status.color && status.color !== 'Pas de couleur' ? status.color : '#ffffff'),
        };
      }
    });
    return mail;
  }

  private setMailSource(mail: Mail): Mail {
    this.sourceListLV.forEach((x) => {
      if (x.value === mail.sourceId) {
        mail.source = x.label;
      }
    });
    return mail;
  }

  private manageMail(response): void {
    this.mails.push(new Mail(response));
    if (!this.mailActive) {
      this.getMailActive(this.mails[0].id);
      this.mailActive = this.mails[0];
      this.mailActive.active = true;
      this.dataService.setMailActive(this.mailActive); // emit to ficheForm and courrierFicheHeader
    }

    this.isLoading = false;
    this.spinner.hide();
  }

  private getAllMailsCount(data: MailsMeSearchParams): void {
    const dataForCount = { ...data, TotalOnly: true };
    this.mailsService.getAllMails(dataForCount).subscribe({
      next: (response) => {
        this.numberCourrier = response.totalCount;
        this.totalPages = this.sizeChoice ? Math.ceil(this.numberCourrier / this.sizeChoice) : 0;
        const boxChosen = this.boxes.find((box) => box.name === this.title);
        if (boxChosen) {
          this.setBoxNameAndCount(boxChosen, this.numberCourrier);
        }
      },
    });
  }
}
